(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  /* GA4 404_error. Reports the attempted URL + referrer so broken links /
     bad campaigns surface in reporting. */
  (function () {
    function publish404() {
      if (window.theme && window.theme.publish) {
        window.theme.publish('eckersleys:404_error', {
          page_location: window.location.href,
          page_referrer: document.referrer,
        });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', publish404);
    } else {
      publish404();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('announcementBar', () => ({
      activeIndex: 0,
      slideCount: 0,
      timer: null,
      paused: false,
      init() {
        this.slideCount = this.$refs.track.children.length;
        this.syncDataAttrs();
        if (this.slideCount < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let ms = parseInt(this.$root.dataset.rotateMs, 10);
        if (!ms || isNaN(ms) || ms < 500) ms = 3000;
        this.timer = setInterval(() => this.advance(), ms);
        this.$watch('activeIndex', () => this.syncDataAttrs());
      },
      advance() {
        if (this.paused) return;
        this.activeIndex = (this.activeIndex + 1) % this.slideCount;
      },
      pause() {
        this.paused = true;
      },
      resume() {
        this.paused = false;
      },
      onFocusOut(event) {
        if (this.$root.contains(event.relatedTarget)) return;
        this.resume();
      },
      syncDataAttrs() {
        Array.from(this.$refs.track.children).forEach((slide, i) => {
          if (i === this.activeIndex) slide.setAttribute('data-active', '');
          else slide.removeAttribute('data-active');
        });
      },
      destroy() {
        if (this.timer) clearInterval(this.timer);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    if (!Alpine.store('cart')) {
      Alpine.store('cart', {
        loading: false,
        item_count: 0,
        items_subtotal_price: 0,
        total_price: 0,
        total_discount: 0,

        init() {
          this.refresh();
        },

        async refresh() {
          try {
            const response = await fetch('/cart.js', {
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
            });
            if (!response.ok) return;
            const data = await response.json();
            this.applyState(data);
          } catch (error) {
            console.error('cart-store refresh failed', error);
          }
        },

        applyState(data) {
          this.item_count = data.item_count ?? 0;
          this.items_subtotal_price = data.items_subtotal_price ?? data.original_total_price ?? 0;
          this.total_price = data.total_price ?? 0;
          this.total_discount = data.total_discount ?? 0;
        },

        /* All three mutating endpoints accept a `sections` query param so
           the response carries the re-rendered HTML for the named section.
           Callers thread their own section id through so we can drop a
           full page reload in favour of an inner-content swap. */
        async updateQuantity(key, quantity, sectionId) {
          this.loading = true;
          try {
            const body = { id: key, quantity };
            if (sectionId) body.sections = sectionId;
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              credentials: 'same-origin',
              body: JSON.stringify(body),
            });
            if (response.ok) {
              const data = await response.json();
              this.applyState(data);
              window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
              return data;
            }
          } finally {
            this.loading = false;
          }
          return null;
        },

        async removeItem(key, sectionId) {
          return this.updateQuantity(key, 0, sectionId);
        },

        async clear(sectionId) {
          this.loading = true;
          try {
            const url = new URL('/cart/clear.js', window.location.origin);
            if (sectionId) url.searchParams.set('sections', sectionId);
            const response = await fetch(url, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
            });
            if (response.ok) {
              const data = await response.json();
              this.applyState(data);
              window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
              return data;
            }
          } finally {
            this.loading = false;
          }
          return null;
        },

        /* Used by callers that mutated the cart through other endpoints
           (e.g. GWP gift-selector's chained /cart/add.js + /cart/change.js
           passes) and need the fresh section HTML without a page reload.
           The `sections` param is only honoured by the cart MUTATION
           endpoints - GET /cart.js ignores it - so the section HTML comes
           from the Section Rendering API on the current path instead. */
        async fetchSection(sectionId) {
          if (!sectionId) return null;
          try {
            const [stateResponse, sectionResponse] = await Promise.all([
              fetch('/cart.js', {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
              }),
              fetch(`${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`, {
                credentials: 'same-origin',
              }),
            ]);
            if (!stateResponse.ok || !sectionResponse.ok) return null;
            const data = await stateResponse.json();
            data.sections = await sectionResponse.json();
            this.applyState(data);
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            return data;
          } catch (error) {
            console.error('cart-store fetchSection failed', error);
            return null;
          }
        },
      });
    }

    Alpine.data('cartPage', () => ({
      sectionId: null,

      init() {
        this.sectionId = this.$root.closest('[data-section-id]')?.dataset.sectionId || null;

        this.$root.addEventListener('cart-item:remove', (event) => {
          this.handleRemove(event.detail.key);
        });
        this.$root.addEventListener('quantity:change', (event) => {
          if (!event.detail.key) return;
          this.handleQty(event.detail.key, event.detail.value);
        });
        /* Every ATC surface dispatches a bubbling `cart:add` that reaches
           `document`. Each add-to-cart POST is owned by its own surface,
           so we only pull the rendered section afterwards. */
        this._onCartAdd = async () => {
          const data = await Alpine.store('cart').fetchSection(this.sectionId);
          this.applySectionHtml(data && data.sections && data.sections[this.sectionId]);
        };
        document.addEventListener('cart:add', this._onCartAdd);
        /* The gift-eligibility guard (cart-offer-banners) dispatches
           `cart:reconcile` after each reconcile pass (it added, trimmed, or
           removed a gift). Re-fetch and swap the section HTML - no toast, no
           page reload - which dispatches `cart:section:rendered` and lets the
           guard run the next pass until the cart is stable. */
        this.$root.addEventListener('cart:reconcile', async () => {
          const data = await Alpine.store('cart').fetchSection(this.sectionId);
          this.applySectionHtml(data && data.sections && data.sections[this.sectionId]);
        });
        /* Cart mutations made OUTSIDE this component dispatch a bubbling
           `cart:refresh` on document. The cart-line "Save for later"
           (wishlist-toast.liquid) removes the line with its own
           /cart/change.js POST and then fires this - without re-rendering,
           the removed line lingers in the DOM with a now-dead line key, so a
           later bin-icon click 404s against a line the server no longer has
           and nothing visibly happens until a reload. Re-fetch and swap the
           section HTML so the stale line leaves the DOM immediately. Listens
           on document because the event is dispatched there (a $root listener
           never sees it). */
        this._onCartRefresh = async () => {
          const data = await Alpine.store('cart').fetchSection(this.sectionId);
          this.applySectionHtml(data && data.sections && data.sections[this.sectionId]);
        };
        document.addEventListener('cart:refresh', this._onCartRefresh);
      },

      destroy() {
        if (this._onCartAdd) {
          document.removeEventListener('cart:add', this._onCartAdd);
        }
        if (this._onCartRefresh) {
          document.removeEventListener('cart:refresh', this._onCartRefresh);
        }
      },

      async handleQty(key, quantity) {
        const data = await Alpine.store('cart').updateQuantity(key, quantity, this.sectionId);
        this.applySectionHtml(data && data.sections && data.sections[this.sectionId]);
      },

      async handleRemove(key) {
        const data = await Alpine.store('cart').removeItem(key, this.sectionId);
        this.applySectionHtml(data && data.sections && data.sections[this.sectionId]);
      },

      async removeAll() {
        const confirmLabel = this.$root.dataset.removeAllConfirm || 'Remove all items from your bag?';
        if (!window.confirm(confirmLabel)) return;
        const data = await Alpine.store('cart').clear(this.sectionId);
        this.applySectionHtml(data && data.sections && data.sections[this.sectionId]);
      },

      /* Surgical inner-content swap. Replaces the live regions
         (`.cart-page__items`, `.cart-page__aside`, and the mobile-only
         rewards banner) with their freshly-rendered counterparts so
         quantity + total + rewards-points updates land without a page
         reload. The desktop rewards banner rides inside `.cart-page__aside`
         already; the mobile banner sits outside both regions, so it's
         swapped separately here. Falls back to swapping the whole
         `.cart-page` inner content when the cart transitions between
         empty and non-empty (the two states have different top-level
         children — `.cart-page__form` vs `.cart-page__empty`). Alpine's
         MutationObserver re-inits directives on the new nodes for us. */
      applySectionHtml(html) {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection = doc.querySelector('.cart-page');
        const currentSection = document.querySelector('.cart-page');
        if (!newSection || !currentSection) return;

        const newItems = newSection.querySelector('.cart-page__items');
        const newAside = newSection.querySelector('.cart-page__aside');
        const currentItems = currentSection.querySelector('.cart-page__items');
        const currentAside = currentSection.querySelector('.cart-page__aside');

        if (newItems && newAside && currentItems && currentAside) {
          currentItems.replaceWith(newItems);
          currentAside.replaceWith(newAside);
          /* Mobile rewards banner lives outside items/aside. Present in
             both trees on a non-empty → non-empty change, so refresh its
             recomputed points. Absent when rewards are disabled — skip. */
          const newRewards = newSection.querySelector('.cart-page__rewards-mobile-wrap');
          const currentRewards = currentSection.querySelector('.cart-page__rewards-mobile-wrap');
          if (newRewards && currentRewards) {
            currentRewards.replaceWith(newRewards);
          }
        } else {
          /* Empty ↔ non-empty transition: swap the whole inner content. */
          currentSection.innerHTML = newSection.innerHTML;
        }

        /* The gift-eligibility guard (cart-offer-banners) reconciles free-gift
           lines against the freshly-rendered [data-gwp-guard] verdicts. It must
           run AFTER this swap - `cart:updated` fires before it - so signal here. */
        window.dispatchEvent(new CustomEvent('cart:section:rendered'));
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('footerColumns', () => ({
      mobileQuery: null,
      onChange: null,
      init() {
        this.mobileQuery = window.matchMedia('(max-width: 1024px)');
        this.onChange = () => this.sync();
        this.mobileQuery.addEventListener('change', this.onChange);
        this.sync();
      },
      sync() {
        const isMobile = this.mobileQuery.matches;
        this.$root.querySelectorAll('[data-footer-column]').forEach((details) => {
          if (isMobile) {
            details.setAttribute('name', 'footer-columns');
            details.removeAttribute('open');
          } else {
            details.removeAttribute('name');
            details.setAttribute('open', '');
          }
        });
      },
      destroy() {
        if (this.mobileQuery && this.onChange) this.mobileQuery.removeEventListener('change', this.onChange);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.store('megaMenu', {
      activeHandle: null,
      toggle(handle) {
        const header = document.querySelector('.header');
        const switching = this.activeHandle && this.activeHandle !== handle;
        if (switching && header) {
          header.classList.add('is-switching');
          requestAnimationFrame(() => requestAnimationFrame(() => header.classList.remove('is-switching')));
        }
        this.activeHandle = this.activeHandle === handle ? null : handle;
      },
      closeAll() {
        this.activeHandle = null;
      },
    });

    document.addEventListener('click', (event) => {
      const store = Alpine.store('megaMenu');
      if (!store.activeHandle) return;
      if (event.target.closest('.header__nav-item, .mega-menu, .header__overlay')) return;
      store.closeAll();
    });
  });

  /* Publishes two live header dimensions on :root:
     - `--sticky-header-h` -- full header section height (main row + nav
       row). Used by sticky content elsewhere (video block heading, etc.)
       and by the instant-search drawer's default inset.
     - `--header-main-row-h` -- just the top row's height (brand + search
       + right-nav). The instant-search drawer switches to this offset
       when open (`:root:has(.header--search-open)` rule above) so the
       drawer's top edge sits at the bottom of the main row and the
       scrim / panel visually overlay the nav row -- no need to
       `display: none` the nav row (which would recalculate
       `--sticky-header-h` and cause a jump). */
  (function() {
    const update = () => {
      const headerSection = document.querySelector('.shopify-section--header');
      if (headerSection) {
        document.documentElement.style.setProperty('--sticky-header-h', `${headerSection.offsetHeight}px`);
      }
      const mainRow = document.querySelector('.header__desktop .header__row--main');
      if (mainRow) {
        document.documentElement.style.setProperty('--header-main-row-h', `${mainRow.offsetHeight}px`);
      }
    };
    const init = () => {
      update();
      window.addEventListener('resize', update, { passive: true });
      if ('ResizeObserver' in window) {
        const headerSection = document.querySelector('.shopify-section--header');
        if (headerSection) new ResizeObserver(update).observe(headerSection);
        const mainRow = document.querySelector('.header__desktop .header__row--main');
        if (mainRow) new ResizeObserver(update).observe(mainRow);
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* Keep the cart bag-count badge in sync after AJAX cart adds. The PDP
     buy-buttons block and Quick Add drawer both dispatch a `cart:add`
     CustomEvent after `/cart/add.js` resolves; the response only includes
     the added line item, not the authoritative total, so we refetch
     `/cart.js` and mirror `item_count` onto every desktop + mobile badge. */
  (function () {
    let inFlight = false;
    function syncBadges(count) {
      const nodes = document.querySelectorAll('[data-header-cart-count]');
      nodes.forEach((node) => {
        node.textContent = String(count);
        if (count > 0) {
          node.removeAttribute('hidden');
        } else {
          node.setAttribute('hidden', '');
        }
      });
      const labels = document.querySelectorAll('[data-header-cart-count-label]');
      labels.forEach((label) => {
        const template = label.getAttribute('data-count-label-template') || '';
        label.textContent = template.replace('__COUNT__', String(count));
      });
    }
    function refresh() {
      if (inFlight) return;
      inFlight = true;
      fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then((res) => res.json())
        .then((cart) => {
          const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
          syncBadges(count);
        })
        .catch(() => { /* silent -- leave last-known count in place */ })
        .finally(() => { inFlight = false; });
    }
    document.addEventListener('cart:add', refresh);
    window.addEventListener('cart:updated', refresh);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh);
    } else {
      refresh();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('hero', () => ({
      activeIndex: 0,
      slides: [],
      autoplay: false,
      rotateMs: 6000,
      // Two pause flags, deliberately separate. `paused` is transient and owned
      // only by hover/focus; `userPaused` is sticky and owned only by the toggle
      // button. Sharing one flag let a mouseleave silently discard an explicit
      // pause, which is the WCAG 2.2.2 mechanism, so the two never write to each
      // other. `shouldRun` honours whichever is set.
      paused: false,
      userPaused: false,
      blockSelected: false,
      timer: null,
      _promoInView: false,
      _promoViewed: null,
      _resizeObserver: null,
      _onWindowResize: null,
      _track: null,
      _onTrackScroll: null,
      _scrollRaf: 0,
      // Set when `applySlideState` programmatically scrolls the track so the
      // subsequent `scroll` event doesn't re-enter and fight itself.
      _suppressScrollSync: false,
      init() {
        this._track = this.$refs.track;
        this.slides = Array.from(this._track.children);
        if (!this.slides.length) return;
        this.autoplay = this.$root.dataset.autoplay === 'true';
        const ms = parseInt(this.$root.dataset.rotateMs, 10);
        if (ms && !isNaN(ms) && ms >= 1000) this.rotateMs = ms;
        this._track.setAttribute('data-initialized', '');
        this.applySlideState();
        this.$watch('activeIndex', () => this.applySlideState());
        this.syncTimer();
        this.setupViewportFit();
        // Listen for native swipe / scroll on the track — only acts on
        // mobile (where the track is a flex row with scroll-snap). Desktop
        // doesn't scroll, so the handler returns early.
        this._onTrackScroll = () => this.onTrackScroll();
        this._track.addEventListener('scroll', this._onTrackScroll, { passive: true });
        this.setupPromoTracking();
      },
      /* view_promotion fires when a slide becomes active while the hero is
         in view — never for all the stacked, cross-faded slides at once.
         select_promotion is delegated in theme-globals. */
      setupPromoTracking() {
        this._promoViewed = new Set();
        if (!('IntersectionObserver' in window)) {
          this._promoInView = true;
          this.trackActivePromo();
          return;
        }
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this._promoInView = true;
            this.trackActivePromo();
          });
        }, { threshold: 0.5 });
        io.observe(this.$root);
      },
      trackActivePromo() {
        const slideEl = this.slides[this.activeIndex];
        if (!slideEl) return;
        const promoEl = slideEl.matches('[data-track-promo-id]')
          ? slideEl
          : slideEl.querySelector('[data-track-promo-id]');
        if (!promoEl) return;
        const id = promoEl.dataset.trackPromoId;
        if (!id || (this._promoViewed && this._promoViewed.has(id))) return;
        this._promoViewed.add(id);
        if (window.theme && window.theme.publish) {
          window.theme.publish('eckersleys:view_promotion', {
            promotion_id: id,
            promotion_name: promoEl.dataset.trackPromoName || '',
          });
        }
      },
      isMobileLayout() {
        return window.matchMedia('(max-width: 768px)').matches;
      },
      onTrackScroll() {
        if (!this.isMobileLayout()) return;
        if (this._suppressScrollSync) return;
        if (this._scrollRaf) return;
        this._scrollRaf = requestAnimationFrame(() => {
          this._scrollRaf = 0;
          const width = this._track.clientWidth;
          if (width <= 0) return;
          const nextIndex = Math.round(this._track.scrollLeft / width);
          if (nextIndex !== this.activeIndex && nextIndex >= 0 && nextIndex < this.slides.length) {
            this._suppressScrollSync = true;
            this.activeIndex = nextIndex;
            // Let one frame pass so applySlideState's no-op early-exit
            // (scrollLeft already matches) keeps the user's gesture
            // authoritative.
            requestAnimationFrame(() => { this._suppressScrollSync = false; });
          }
        });
      },
      setupViewportFit() {
        if (!this.$root.classList.contains('hero--fit-viewport')) return;
        const measure = () => this.measureViewportOffset();
        measure();
        this._onWindowResize = () => measure();
        window.addEventListener('resize', this._onWindowResize, { passive: true });
        // Watch the surrounding sections so changes (logo swap, USP scheme,
        // announcement bar block edits) reflow the hero offset without a
        // page reload — handy in the theme editor.
        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(measure);
          const targets = [
            document.querySelector('.section-announcement-bar'),
            document.querySelector('.shopify-section--header'),
            document.querySelector('[data-usp-bar]')?.closest('.shopify-section'),
          ].filter(Boolean);
          targets.forEach((el) => this._resizeObserver.observe(el));
        }
      },
      measureViewportOffset() {
        const announcement = document.querySelector('.section-announcement-bar');
        const header = document.querySelector('.shopify-section--header');
        const usp = document.querySelector('[data-usp-bar]')?.closest('.shopify-section');
        const total = (announcement?.offsetHeight || 0)
          + (header?.offsetHeight || 0)
          + (usp?.offsetHeight || 0);
        if (total > 0) {
          this.$root.style.setProperty('--hero-viewport-offset', `${total}px`);
        }
      },
      applySlideState() {
        this.slides.forEach((slide, i) => {
          if (i === this.activeIndex) {
            slide.setAttribute('data-active', '');
            slide.removeAttribute('aria-hidden');
          } else {
            slide.removeAttribute('data-active');
            slide.setAttribute('aria-hidden', 'true');
          }
          // Sync each slide's pagination dots to the active index. Each slide
          // ships its own dots (rendered server-side with the first dot active);
          // Alpine reassigns the active class so the visible slide always shows
          // the right position.
          const dots = slide.querySelectorAll('[data-hero-dots] .pagination-indicator__dot');
          dots.forEach((dot, idx) => {
            dot.classList.toggle('pagination-indicator__dot--active', idx === this.activeIndex);
          });
          const indicator = slide.querySelector('[data-hero-dots] [role="progressbar"]');
          if (indicator) indicator.setAttribute('aria-valuenow', String(this.activeIndex + 1));
        });
        // The arrows and pause toggle live on the section but sit over whichever
        // slide is active, so their treatment is a per-slide setting synced here
        // like the dots: the theme's translucent default, or a solid black/white
        // plate for slides whose imagery drowns the translucent one.
        const activeSlide = this.slides[this.activeIndex];
        const controlEl = activeSlide && (activeSlide.matches('[data-hero-controls]')
          ? activeSlide
          : activeSlide.querySelector('[data-hero-controls]'));
        const scheme = controlEl ? controlEl.dataset.heroControls : 'translucent';
        const solid = scheme === 'black' || scheme === 'white';
        this.$root.querySelectorAll('.hero__arrow').forEach((btn) => {
          btn.classList.toggle('button--solid', solid);
          btn.classList.toggle('button--opacity', !solid);
          btn.classList.toggle('button--black', scheme === 'black');
          btn.classList.toggle('button--white', scheme !== 'black');
        });
        if (this._promoInView) this.trackActivePromo();
        // On mobile, scroll the track to the active slide ONLY when the
        // index change came from programmatic code (autoplay, arrow click,
        // editor block-select). When the change came from a user swipe,
        // `onTrackScroll` has set `_suppressScrollSync` first — in that
        // case the browser is already snapping to the right slide and a
        // redundant `scrollTo` here would visibly bump the gesture.
        if (this.isMobileLayout() && this._track && !this._suppressScrollSync) {
          const width = this._track.clientWidth;
          if (width > 0) {
            const targetX = this.activeIndex * width;
            if (Math.abs(this._track.scrollLeft - targetX) > 1) {
              this._suppressScrollSync = true;
              this._track.scrollTo({ left: targetX, behavior: 'smooth' });
              // Release the suppress flag after the smooth scroll settles
              // (400ms is a comfortable upper bound for a 1-slide hop).
              setTimeout(() => { this._suppressScrollSync = false; }, 400);
            }
          }
        }
      },
      shouldRun() {
        if (!this.autoplay) return false;
        if (this.paused || this.userPaused || this.blockSelected) return false;
        if (this.slides.length < 2) return false;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
        return true;
      },
      syncTimer() {
        if (this.shouldRun()) {
          if (this.timer) return;
          this.timer = setInterval(() => this.next(), this.rotateMs);
        } else if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      goTo(index) {
        const len = this.slides.length;
        if (!len) return;
        this.activeIndex = (index + len) % len;
      },
      next() {
        this.goTo(this.activeIndex + 1);
      },
      prev() {
        this.goTo(this.activeIndex - 1);
      },
      toggleUserPause() {
        this.userPaused = !this.userPaused;
        this.syncTimer();
      },
      pause() {
        this.paused = true;
        this.syncTimer();
      },
      resume() {
        this.paused = false;
        this.syncTimer();
      },
      // A finger fires pointerenter (and a compatibility mouseenter) but never a
      // matching leave, because a touch lifts rather than moves away. Pausing on
      // that stuck the rotation off permanently on mobile, where the controls are
      // hidden and there is nothing to undo it with. Only a pointer that can
      // genuinely hover should pause.
      onPointerEnter(event) {
        if (event.pointerType === 'touch') return;
        this.pause();
      },
      onPointerLeave(event) {
        if (event.pointerType === 'touch') return;
        this.resume();
      },
      onFocusOut(event) {
        if (this.$root.contains(event.relatedTarget)) return;
        this.resume();
      },
      onBlockSelect(event) {
        const slideEl = event.detail.block?.closest?.('.shopify-block');
        if (!slideEl) return;
        const index = this.slides.indexOf(slideEl);
        if (index < 0) return;
        this.blockSelected = true;
        this.goTo(index);
        this.syncTimer();
      },
      onBlockDeselect() {
        this.blockSelected = false;
        this.syncTimer();
      },
      destroy() {
        if (this.timer) clearInterval(this.timer);
        if (this._onWindowResize) window.removeEventListener('resize', this._onWindowResize);
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this._onTrackScroll && this._track) {
          this._track.removeEventListener('scroll', this._onTrackScroll);
        }
        if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('imageWithProduct', () => ({
      atStart: true,
      atEnd: false,
      _rafId: null,
      _track: null,
      init() {
        this._track = this.$root.querySelector('[data-iwp-track]');
        if (!this._track) return;
        this._track.addEventListener('scroll', () => this.schedule(), { passive: true });
        this.$nextTick(() => this.measure());
      },
      measure() {
        const t = this._track;
        if (!t) return;
        this.atStart = t.scrollLeft <= 1;
        this.atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1;
      },
      schedule() {
        if (this._rafId) return;
        this._rafId = requestAnimationFrame(() => {
          this._rafId = null;
          this.measure();
        });
      },
      step(direction) {
        const t = this._track;
        if (!t) return;
        // 'auto' defers to the track's CSS scroll-behavior: smooth normally,
        // instant under the prefers-reduced-motion backstop in tokens.css.
        t.scrollBy({ left: direction * t.clientWidth * 0.85, behavior: 'auto' });
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('instagramCarousel', () => ({
      _rafId: 0,
      _lastTime: 0,
      _loopWidth: 0,
      _track: null,
      _speed: 50,
      _onResize: null,
      _scrollX: 0,
      init() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.Shopify?.designMode) return;
        this._track = this.$root.querySelector('[data-hscroll-track]');
        if (!this._track || this._track.children.length < 1) return;

        this._speed = parseFloat(this.$root.dataset.igScrollSpeed) || 50;
        this._cloneItems();
        this._measure();
        this._onResize = () => this._measure();
        window.addEventListener('resize', this._onResize);
        this._rafId = requestAnimationFrame((t) => this._tick(t));
      },
      _cloneItems() {
        if (this._track.querySelector('[data-ig-clone]')) return;
        Array.from(this._track.children).forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-ig-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          this._track.appendChild(clone);
        });
      },
      _measure() {
        const items = this._track.children;
        const half = items.length / 2;
        if (half < 1) return;
        let width = 0;
        const gap = parseFloat(getComputedStyle(this._track).gap) || 0;
        for (let i = 0; i < half; i++) {
          width += items[i].getBoundingClientRect().width;
          if (i < half - 1) width += gap;
        }
        this._loopWidth = width;
      },
      _tick(time) {
        this._rafId = requestAnimationFrame((t) => this._tick(t));
        // Re-measure each frame while loopWidth is still zero — early init
        // sometimes runs before tiles have laid out (Alpine boots before
        // images / cloned nodes resolve), and without this the loop would
        // be stuck forever once that happens.
        if (this._loopWidth <= 0) {
          this._measure();
          if (this._loopWidth <= 0) return;
          this._lastTime = 0;
          this._scrollX = this._track.scrollLeft;
        }
        if (!this._lastTime) { this._lastTime = time; return; }
        const delta = (time - this._lastTime) / 1000;
        this._lastTime = time;
        // Accumulate position in a float we own. Most browsers round
        // `scrollLeft` on write (e.g. 100.4 → 100), so `scrollLeft += 0.4`
        // would lose the fractional component every frame and the carousel
        // would never advance. Storing the float ourselves and assigning it
        // each frame lets the integer scroll position progress 1px at a time
        // once the accumulator crosses the rounding boundary.
        this._scrollX += this._speed * delta;
        if (this._scrollX >= this._loopWidth) {
          this._scrollX -= this._loopWidth;
        }
        this._track.scrollLeft = this._scrollX;
      },
      destroy() {
        if (this._rafId) cancelAnimationFrame(this._rafId);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('blogFilterBar', () => ({
      isStuck: false,
      observer: null,
      moreDropdowns: [],
      onDropdownToggle: null,
      onDocumentPointerdown: null,

      init() {
        if (!this.$refs.filterSentinel) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry) return;
            // Sentinel below the viewport top = bar has stuck.
            this.isStuck = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          },
          { threshold: 0, rootMargin: '0px 0px 0px 0px' }
        );
        this.observer.observe(this.$refs.filterSentinel);

        this.$root.addEventListener('change', this.handleChange.bind(this));

        this.initMoreDropdowns();
      },

      // Per-group "+N" overflow dropdowns are native <details>. Enforce
      // one-open-at-a-time and close-on-outside-click here rather than
      // per-group so a single controller owns the shared state.
      initMoreDropdowns() {
        this.moreDropdowns = Array.from(
          this.$root.querySelectorAll('.blog-filter-group__more')
        );
        if (this.moreDropdowns.length === 0) return;

        this.onDropdownToggle = (event) => {
          const opened = event.target;
          if (!opened.open) return;
          this.moreDropdowns.forEach((d) => {
            if (d !== opened) d.open = false;
          });
        };
        this.moreDropdowns.forEach((d) =>
          d.addEventListener('toggle', this.onDropdownToggle)
        );

        // Pointerdown (not click) so the dropdown closes before a click
        // inside another opens it, and without the summary's click
        // default action fighting the close.
        this.onDocumentPointerdown = (event) => {
          this.moreDropdowns.forEach((d) => {
            if (d.open && !d.contains(event.target)) d.open = false;
          });
        };
        document.addEventListener('pointerdown', this.onDocumentPointerdown);
      },

      destroy() {
        if (this.observer) this.observer.disconnect();
        if (this.onDocumentPointerdown) {
          document.removeEventListener('pointerdown', this.onDocumentPointerdown);
        }
        if (this.onDropdownToggle) {
          this.moreDropdowns.forEach((d) =>
            d.removeEventListener('toggle', this.onDropdownToggle)
          );
        }
      },

      get activeTags() {
        const root = this.$root;
        if (!root) return [];
        // The same tag value can appear as a checkbox in both the
        // desktop bar AND the drawer (both rendered by Liquid from
        // `current_tags`). De-dupe to avoid emitting the tag twice
        // in the resulting `/tagged/<slug>+<slug>` URL, which 404s.
        const inputs = root.querySelectorAll('input[name="filter.tag"]:checked');
        return Array.from(new Set(Array.from(inputs).map((el) => el.value)));
      },

      // Checked tags in the desktop bar ONLY. The same tag is mirrored as a
      // checkbox in the drawer, so a bar deselect must commit off the bar's
      // own state — the union (`activeTags`) still sees the drawer's untouched
      // copy and would rebuild the same URL, making deselect a no-op.
      get activeBarTags() {
        const wrap = this.$root?.querySelector('[data-main-blog-filter-wrap]');
        if (!wrap) return [];
        const inputs = wrap.querySelectorAll('input[name="filter.tag"]:checked');
        return Array.from(new Set(Array.from(inputs).map((el) => el.value)));
      },

      get hasActiveTags() {
        return this.activeTags.length > 0;
      },

      get resultLabel() {
        const count = parseInt(
          (this.$root && this.$root.dataset && this.$root.dataset.resultCount) || '0',
          10
        );
        // Renders e.g. "12 articles" using the embedded server-rendered label fallback.
        return this.$root.querySelector('[data-blog-filter-count]')?.textContent?.trim() || '';
      },

      get applyLabel() {
        const count = this.activeTags.length;
        if (count === 0) return this.$root.dataset.applyDefault || 'Apply';
        return `Apply (${count})`;
      },

      buildUrl(tags) {
        const blogUrl = this.$root.dataset.blogUrl || window.location.pathname.split('/tagged/')[0];
        if (!tags || tags.length === 0) return blogUrl;
        // Shopify-native blog tag filter URL contract:
        //   /blogs/<handle>/tagged/<slug>            (single tag)
        //   /blogs/<handle>/tagged/<slug>+<slug>...  (AND multi tag)
        // Slug must match Shopify's `handleize` of the tag (the route Shopify
        // actually serves): lowercase, DROP apostrophes/quotes entirely so
        // "Mother's" -> "mothers" (not "mother-s"), then collapse any other
        // non-alphanumeric run to a single "-" and trim.
        const slugify = (t) =>
          String(t)
            .toLowerCase()
            .replace(/['’`]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        return `${blogUrl}/tagged/${tags.map(slugify).join('+')}`;
      },

      handleChange(event) {
        const target = event.target;
        if (!target || target.name !== 'filter.tag') return;
        // Desktop bar commits on change. Drawer collects without
        // navigating until Apply is pressed.
        const inDrawer = target.closest('.blog-filter-drawer') !== null;
        if (inDrawer) return;
        this.commit(this.activeBarTags);
      },

      commit(tags) {
        window.location.href = this.buildUrl(tags);
      },

      clearAll() {
        // Reset visible checkboxes; on desktop, commit immediately.
        const root = this.$root;
        const inputs = root.querySelectorAll('input[name="filter.tag"]');
        inputs.forEach((el) => {
          el.checked = false;
        });
        const inDrawer = document.activeElement?.closest('.blog-filter-drawer') !== null;
        if (!inDrawer) this.commit([]);
      },

      applyDrawer() {
        // Commit only the drawer's selected tags. The desktop bar shares
        // the same form names, so we read selected boxes from inside the
        // drawer DOM specifically. De-dupe via Set in case the drawer
        // ends up with duplicate checkbox entries (it shouldn't, but
        // matches the safety guard on `activeTags`).
        const drawer = document.getElementById('blog-filter-drawer');
        if (!drawer) {
          this.commit(this.activeTags);
          return;
        }
        const tags = Array.from(new Set(
          Array.from(drawer.querySelectorAll('input[name="filter.tag"]:checked'))
            .map((el) => el.value)
        ));
        this.commit(tags);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  /* `Alpine.data('productForm', ...)` — section-root shell. Mounts on
     the `<section data-main-product>` via `x-data="productForm"`. Two
     responsibilities only:
       1. Idempotently bootstrap `Alpine.store('pdp')` from the data
          attributes Liquid emitted on this section + its descendants.
       2. Kick off the lazy `/products/{handle}.js` fetch and dispatch
          `pdp:payload` once the payload lands so the picker can
          re-resolve `variantId` from the live selection.
     Every other PDP behaviour (variant picking, gallery, buy-button
     submit, zoom) lives in its own focused Alpine factory reading
     from `$store.pdp`. */
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('productForm', () => ({
      init() {
        const store = this.$store.pdp;
        store.init(this.$root);
        store.loadPayload().then((payload) => {
          if (!payload) return;
          document.dispatchEvent(
            new CustomEvent('pdp:payload', { detail: { payload } })
          );
        });
      },
    }));
  });

  /* Desktop-only scroll-jack. The info panel is `position: sticky` and
     opens its own scroll surface when its content overflows. A wheel
     over the gallery or the info itself is forwarded to that inner
     scroll first — so the reader walks through every option / stock
     indicator / find-in-store step before the page continues on. Once
     the info hits its top or bottom, the wheel returns to its default
     behaviour and the page scrolls normally. */
  document.addEventListener('DOMContentLoaded', () => {
    const desktopQuery = window.matchMedia('(min-width: 1025px)');

    document.querySelectorAll('[data-main-product]').forEach((section) => {
      const gallery = section.querySelector('.main-product__gallery');
      const info = section.querySelector('.main-product__info');
      if (!info) return;

      const forwardWheelToInfo = (event) => {
        if (!desktopQuery.matches) return;

        /* Modal drawers (find in store, quick add, wishlist) are rendered
           inside the info column, so their wheel events bubble up to this
           listener — including wheels over the backdrop, which target the
           <dialog> itself. Forwarding those would scroll the buy panel
           behind the open drawer, which is the #1043 report. `scrollTop`
           is settable even when the panel is `overflow: hidden`, so the
           scroll lock in critical.css cannot cover this; the handler has
           to stand down itself. A modal also makes the rest of the page
           inert, so there is nothing legitimate to scroll-jack meanwhile. */
        if (event.target?.closest?.('dialog[open]')) return;
        if (document.querySelector('dialog[scroll-lock][open]')) return;

        if (info.scrollHeight <= info.clientHeight) return;

        const delta = event.deltaY;
        if (delta === 0) return;

        const atBottom =
          Math.ceil(info.scrollTop + info.clientHeight) >= info.scrollHeight;
        const atTop = info.scrollTop <= 0;

        if (delta > 0 && !atBottom) {
          event.preventDefault();
          info.scrollTop += delta;
        } else if (delta < 0 && !atTop) {
          event.preventDefault();
          info.scrollTop += delta;
        }
      };

      if (gallery) {
        gallery.addEventListener('wheel', forwardWheelToInfo, { passive: false });
      }
      info.addEventListener('wheel', forwardWheelToInfo, { passive: false });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('multiColumnCarousel', () => ({
      atStart: true,
      atEnd: false,
      _track: null,
      _rafId: null,
      _onResize: null,
      init() {
        this._track = this.$root.querySelector('[data-mc-track]');
        if (!this._track) return;
        this._track.addEventListener('scroll', () => this.schedule(), { passive: true });
        this._onResize = () => this.schedule();
        window.addEventListener('resize', this._onResize);
        this.measure();
      },
      measure() {
        if (!this._track) return;
        this.atStart = this._track.scrollLeft <= 1;
        this.atEnd = this._track.scrollLeft + this._track.clientWidth >= this._track.scrollWidth - 1;
      },
      schedule() {
        if (this._rafId) return;
        this._rafId = requestAnimationFrame(() => {
          this._rafId = null;
          this.measure();
        });
      },
      step(direction) {
        if (!this._track) return;
        this._track.scrollBy({ left: direction * this._track.clientWidth * 0.85, behavior: 'smooth' });
      },
      destroy() {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('productCarousel', () => ({
      activeBlockId: null,
      atStart: true,
      atEnd: false,
      _rafId: null,
      init() {
        const firstPanel = this.$root.querySelector('[data-pc-panel-id]');
        if (firstPanel) this.activeBlockId = firstPanel.dataset.pcPanelId;
        this.$root.querySelectorAll('[data-pc-track]').forEach((track) => {
          track.addEventListener('scroll', () => this.schedule(), { passive: true });
        });
        this.$watch('activeBlockId', () => this.$nextTick(() => this.measure()));
        this.$nextTick(() => this.measure());
      },
      _activeTrack() {
        const panel = this.$root.querySelector(`[data-pc-panel-id="${this.activeBlockId}"]`);
        return panel?.querySelector('[data-pc-track]') || null;
      },
      measure() {
        const t = this._activeTrack();
        if (!t) return;
        this.atStart = t.scrollLeft <= 1;
        this.atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1;
      },
      schedule() {
        if (this._rafId) return;
        this._rafId = requestAnimationFrame(() => {
          this._rafId = null;
          this.measure();
        });
      },
      setActive(blockId) {
        this.activeBlockId = blockId;
      },
      step(direction) {
        const t = this._activeTrack();
        if (!t) return;
        t.scrollBy({ left: direction * t.clientWidth * 0.85, behavior: 'smooth' });
      },
      rotateFocus(direction) {
        const tabs = Array.from(this.$root.querySelectorAll('[data-pc-tab]'));
        const i = tabs.findIndex((t) => t.dataset.pcTab === this.activeBlockId);
        if (i === -1) return;
        const next = tabs[(i + direction + tabs.length) % tabs.length];
        this.activeBlockId = next.dataset.pcTab;
        next.focus();
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-colour-variants"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('colourVariantsFilter', () => ({
      activeColourGroup: '',
      activeSeries: '',

      onDropdownChange(event) {
        const ddRoot = event.target && event.target.closest('.dropdown');
        if (!ddRoot) return;
        const hidden = ddRoot.querySelector('input[type="hidden"]');
        if (!hidden) return;
        const value = (event.detail && event.detail.value) || '';
        if (hidden.name === 'colour_group') {
          this.activeColourGroup = value;
          this.applyFilter();
        } else if (hidden.name === 'series') {
          this.activeSeries = value;
          this.applyFilter();
        } else {
          return;
        }
        this.publishFilter(hidden.name, value);
      },

      /* colour_filter_interaction. product_id is the parent SKU
         (custom.source_id) rendered onto the section root. One event per
         selection. */
      publishFilter(filterName, filterValue) {
        const section = this.$root.closest('[data-product-colour-variants]');
        if (!section || !window.theme || !window.theme.publish) return;
        window.theme.publish('eckersleys:colour_filter_interaction', {
          filter_name: filterName,
          filter_value: filterValue,
          product_id: section.dataset.sourceId || '',
          product_name: section.dataset.productName || '',
        });
      },

      applyFilter() {
        const section = this.$root.closest('[data-product-colour-variants]');
        if (!section) return;
        const group = this.activeColourGroup;
        const series = this.activeSeries;
        section.querySelectorAll('[data-colour-card-cell]').forEach((cell) => {
          const groupMatch = !group || cell.dataset.colourGroup === group;
          const seriesMatch = !series || cell.dataset.colourSeries === series;
          cell.hidden = !(groupMatch && seriesMatch);
        });
      },
    }));
  });

  /* Colour-variant cards grid (grid template). Wires the per-colour cards:
       - resolves each card's variant against the live non-colour selection
         broadcast on `main-options:change` by the variant picker
       - paints price / compare-at / disabled state
       - submits each card's tiny <form> to /cart/add.js and dispatches the
         global `cart:add` event so the shared toast picks it up
     Also owns the `[data-product-scroll-to-colours]` click handler used
     by the grid-template "Select Colours" CTA in the main buy buttons.
     Consumes `window.theme.loadProductJson` + `window.theme.formatMoney`
     (provided by `theme-globals.js`). */
  (function () {
    function formatMoney(amountCents, format) {
      if (window.theme && typeof window.theme.formatMoney === 'function') {
        return window.theme.formatMoney(amountCents, format);
      }
      return `$${(amountCents / 100).toFixed(2)}`;
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-product-scroll-to-colours]');
      if (!trigger) return;
      const section = document.querySelector('[data-product-colour-variants]');
      if (!section) return;
      /* Scroll the filter bar (not the section root) to just underneath
         the sticky header. Using the filter-bar rect + the live
         --sticky-header-h var means the filter bar always lands flush
         under the nav regardless of section chrome or header height. */
      const target = section.querySelector('.product-colour-variants__filter-bar') || section;
      const headerRaw = getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-h');
      const headerH = parseFloat(headerRaw) || 0;
      const targetY = target.getBoundingClientRect().top + window.scrollY - headerH;
      window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
    });

    function setupColourVariantsSection() {
      const section = document.querySelector('[data-product-colour-variants]');
      if (!section || section.dataset.colourVariantsReady === '1') return;
      section.dataset.colourVariantsReady = '1';

      const colourPosition = Number(section.dataset.colourPosition || 0);
      const cards = Array.from(section.querySelectorAll('[data-colour-card]'));
      const mainProductRoot = document.querySelector('[data-main-product]');
      const productHandle = mainProductRoot && mainProductRoot.dataset.productHandle;
      const moneyFormat = (window.theme && window.theme.moneyFormat) || undefined;
      const ctaLabelDefault = section.dataset.ctaLabelDefault || 'Add to Bag';
      const ctaLabelOos = section.dataset.ctaLabelOos || 'Out Of Stock';
      /* Liquid-rendered OOS ids (warehouse mirror) — the payload's
         `variant.available` is always true under native CONTINUE. */
      const oosIds = new Set((section.dataset.oosIds || '').split(',').filter(Boolean));
      /* Variants hidden from the Online Store channel — passed to
         loadProductJson so `applyCards` re-resolves against the same
         filtered payload the server used to omit cards. Empty for an
         all-online product. */
      const channelHiddenIds = new Set((section.dataset.channelHiddenIds || '').split(',').filter(Boolean));
      /* Members pricing: percentage resolved server-side by the section's
         single 'members-percentage' walk, plus the variant gate (empty =
         every variant). Repainting rather than re-rendering, so the markup
         must already exist in the card - see the price row comment. */
      const membersPercentage = Number(section.dataset.membersPercentage || 0);
      const membersGateIds = (section.dataset.membersGateVariantIds || '')
        .split(',')
        .filter(Boolean);
      /* Localised "__PERCENT__% Off" pattern for the percent-off badge, so a
         repaint reuses the same string the server rendered. */
      const saleLabelTemplate = section.dataset.saleLabelTemplate || '';

      let productPayload = null;
      let pendingValues = null;

      function setCardEnabled(card, isEnabled, ctaLabel) {
        const submitBtn = card.querySelector('[type="submit"]');
        if (submitBtn) {
          if (isEnabled) {
            submitBtn.removeAttribute('disabled');
          } else {
            submitBtn.setAttribute('disabled', 'true');
          }
          const labelNode = submitBtn.querySelector('.button__label');
          if (labelNode && ctaLabel) labelNode.textContent = ctaLabel;
        }
        const qty = card.querySelector('.quantity-selector');
        if (qty) {
          if (isEnabled) {
            qty.removeAttribute('data-disabled');
          } else {
            qty.setAttribute('data-disabled', '');
          }
          qty.querySelectorAll('input, button').forEach((node) => {
            if (isEnabled) {
              node.removeAttribute('disabled');
            } else {
              node.setAttribute('disabled', 'true');
            }
          });
        }
      }

      /* Percent-off badge for a re-resolved variant. Same precedence and the
         same integer floor as the Liquid render (and `sale-badge`): this
         variant's own markdown first, the members percentage when it is full
         price and in the gate, hidden when neither applies. */
      function applyCardBadge(card, variant, onSale) {
        const badge = card.querySelector('[data-card-sale-badge]');
        if (!badge) return;
        /* Relabel the shared badge's inner text node, not the wrapper - the
           wrapper holds the pill markup. */
        const label = badge.querySelector('.badge__label');
        if (!label) return;

        let percentage = 0;
        if (onSale) {
          percentage = Math.floor(
            ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
          );
        } else if (membersPercentage > 0 && isMembersVariant(variant)) {
          percentage = membersPercentage;
        }

        if (percentage > 0) {
          label.textContent = saleLabelTemplate.replace('__PERCENT__', percentage);
        }
        badge.hidden = percentage <= 0;
      }

      /* Variant-targeted members offer: only the listed variants qualify.
         Empty gate = product-level match, every variant covered. */
      function isMembersVariant(variant) {
        return membersGateIds.length === 0 || membersGateIds.indexOf(String(variant.id)) !== -1;
      }

      /* Swap the plain price row for the members block (or back) and repaint
         both figures for the card's newly resolved variant. Mirrors the
         server-side gates exactly: full-price variant only, and inside the
         variant gate when the discount targets specific variants. Rounding
         matches the Liquid `| round` so a repaint never disagrees with the
         first render. */
      function applyCardMembers(card, variant, onSale) {
        const membersRow = card.querySelector('[data-card-members-price]');
        const plainRow = card.querySelector('[data-card-plain-price]');
        if (!membersRow || !plainRow) return;

        const showMembers = membersPercentage > 0 && !onSale && isMembersVariant(variant);

        if (showMembers) {
          const membersValue = Math.round((variant.price * (100 - membersPercentage)) / 100);
          const regularNode = membersRow.querySelector('.members-price__value--regular');
          const membersNode = membersRow.querySelector('.members-price__value--members');
          if (regularNode) regularNode.textContent = formatMoney(variant.price, moneyFormat);
          if (membersNode) membersNode.textContent = formatMoney(membersValue, moneyFormat);
        }

        membersRow.hidden = !showMembers;
        plainRow.hidden = showMembers;
      }

      function applyCards(values) {
        if (!productPayload) return;
        cards.forEach((card) => {
          const colourValue = card.dataset.colourValue;
          const variant = productPayload.variants.find((v) =>
            v.options.every((optValue, index) => {
              const pos = index + 1;
              if (pos === colourPosition) return optValue === colourValue;
              if (values && values[pos] !== undefined) return optValue === values[pos];
              return true;
            })
          );
          if (!variant) {
            card.setAttribute('data-unavailable', '');
            setCardEnabled(card, false, ctaLabelOos);
            return;
          }
          card.removeAttribute('data-unavailable');
          const hidden = card.querySelector('[data-card-variant-id]');
          if (hidden) hidden.value = String(variant.id);
          const priceNode = card.querySelector('[data-card-price]');
          if (priceNode) priceNode.textContent = formatMoney(variant.price, moneyFormat);
          const onSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
          const compareNode = card.querySelector('[data-card-compare-price]');
          if (compareNode) {
            if (onSale) {
              compareNode.textContent = formatMoney(variant.compare_at_price, moneyFormat);
              compareNode.hidden = false;
              if (priceNode) priceNode.classList.add('product-colour-card__price-value--sale');
            } else {
              compareNode.hidden = true;
              if (priceNode) priceNode.classList.remove('product-colour-card__price-value--sale');
            }
          }
          applyCardBadge(card, variant, onSale);
          applyCardMembers(card, variant, onSale);
          const variantInStock = !oosIds.has(String(variant.id));
          setCardEnabled(card, variantInStock, variantInStock ? ctaLabelDefault : ctaLabelOos);
        });
      }

      document.addEventListener('main-options:change', (event) => {
        pendingValues = event.detail && event.detail.values;
        if (productPayload) applyCards(pendingValues);
      });

      if (productHandle && window.theme && typeof window.theme.loadProductJson === 'function') {
        window.theme.loadProductJson(productHandle, channelHiddenIds).then((payload) => {
          productPayload = payload;
          if (pendingValues) applyCards(pendingValues);
        });
      }

      /* Delegated on document (submit bubbles) so cards rendered later keep
         AJAX add-to-cart. A grouped-product size switch swaps this grid in via
         the Section Rendering API; per-form listeners wouldn't survive that and
         the card would native-submit to /cart. One delegated listener covers
         every card form, now and after a swap. */
      document.addEventListener('submit', (event) => {
        const form = event.target.closest ? event.target.closest('[data-colour-card-form]') : null;
        if (!form) return;
        event.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        /* Only this card's button goes pending; siblings stay clickable and
           enqueue. The shared queue serialises the writes so concurrent
           adds across cards never collide (409). */
        if (submitBtn) submitBtn.setAttribute('disabled', 'true');
        const body = new FormData(form);
        window.theme
          .cartAdd(body)
          .then((payload) => {
            document.dispatchEvent(new CustomEvent('cart:add', { detail: { item: payload } }));
          })
          .catch((error) => {
            document.dispatchEvent(new CustomEvent('cart:add:error', { detail: { error } }));
          })
          .finally(() => {
            if (submitBtn) submitBtn.removeAttribute('disabled');
          });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupColourVariantsSection);
    } else {
      setupColourVariantsSection();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /* `Alpine.data('productRecommendationsCarousel', ...)` — section-specific
     wrapper over the shared `window.theme.scrollCarousel` factory. Bakes in
     the trackSelector + loadedAttribute + loader so the `x-data` attribute
     stays a bare name (no inline logic in HTML attributes). The loader
     fetches `[data-url]` (a `/recommendations/products?section_id=…` URL
     emitted by Liquid), parses the response, and returns the inner HTML of
     the fresh `[data-pr-track]` so the factory can splat it into the live
     track. */
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('productRecommendationsCarousel', () =>
      window.theme.scrollCarousel({
        trackSelector: '[data-pr-track]',
        loadedAttribute: 'data-pr-loaded',
        loader: async function () {
          const url = this.$root.dataset.url;
          if (!url) return null;
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('recommendations fetch failed');
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-pr-track]');
          if (!fresh || fresh.children.length === 0) return null;
          return fresh.innerHTML;
        },
      })
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order-save-drawer"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('quickOrderSaveDrawer', () => ({
      items: [],
      lists: [],
      newListName: '',
      creating: false,
      // Labels hydrated from `data-qo-save-labels` on the root in init().
      handlers: null,
      itemsLabel(count) {
        const n = Number(count) || 0;
        return n + ' ' + (n === 1 ? 'item' : (this.itemsSuffix || 'items'));
      },
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.qoSaveLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[quick-order-save-drawer] labels JSON parse failed:', err);
        }
      },
      async open(event) {
        this.items = (event && event.detail && Array.isArray(event.detail.items)) ? event.detail.items : [];
        this.newListName = '';
        const dialog = document.getElementById('quick-order-save-drawer');
        if (dialog && typeof dialog.showModal === 'function') {
          try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        } else if (dialog) {
          dialog.setAttribute('open', '');
        }
        try {
          const raw = await window.EckList.getLists();
          this.lists = (raw || []).map((l) => ({
            lid: l.lid,
            lname: l.lname,
            cnt: l.cnt || (Array.isArray(l.listcontents) ? l.listcontents.length : 0),
            pending: false,
          }));
        } catch (err) {
          this.lists = [];
        }
      },
      async addToList(list) {
        if (list.pending) return;
        if (!this.items.length) return;
        list.pending = true;
        try {
          let added = 0;
          for (const item of this.items) {
            try {
              await window.EckList.addProduct(list.lid, item);
              added++;
            } catch (e) {
              // Skip individual failures - Swym silently dedupes duplicates.
            }
          }
          document.dispatchEvent(new CustomEvent('wishlist:toast', {
            detail: {
              kind: 'added',
              lid: list.lid,
              lname: list.lname,
              item: { dt: added + ' item(s)' },
            },
            bubbles: true,
          }));
        } finally {
          list.pending = false;
        }
      },
      createAndAdd() {
        // Close the drawer, then dispatch open-create.
        // The create modal only accepts a SINGLE product context, so
        // when saving multiple items via "Create & Add to list" the
        // create flow will only chain the first item into the new
        // list; the rest are added via a separate follow-up call.
        if (this.creating) return;
        this.creating = true;
        const dialog = document.getElementById('quick-order-save-drawer');
        if (dialog && typeof dialog.close === 'function') dialog.close();
        const firstItem = this.items[0] || {};
        document.dispatchEvent(new CustomEvent('wishlist:open-create', {
          detail: {
            variantId: firstItem.variantId || null,
            productId: firstItem.productId || null,
            url: firstItem.url || '',
            prefillName: this.newListName.trim(),
            followupItems: this.items.slice(1),
          },
          bubbles: true,
        }));
        this.creating = false;
      },
      init() {
        this.hydrateLabels();
        const onOpen = (event) => this.open(event);
        document.addEventListener('wishlist:open-save-drawer', onOpen);
        this.handlers = { onOpen };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('wishlist:open-save-drawer', this.handlers.onOpen);
        this.handlers = null;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order"]) return;
  try {
    
  // Match ranks (lower = better): exact > startsWith > contains.
  function variantMatchesSku(variant, q) {
    if (!variant || !variant.sku) return false;
    const sku = String(variant.sku).toLowerCase();
    const needle = String(q || '').toLowerCase();
    if (!needle) return false;
    return sku.indexOf(needle) !== -1;
  }

  function skuMatchRank(q) {
    const needle = String(q || '').toLowerCase();
    return (a, b) => {
      const rank = (entry) => {
        const sku = String(entry.variant.sku || '').toLowerCase();
        if (sku === needle) return 0;
        if (sku.startsWith(needle)) return 1;
        return 2;
      };
      const ra = rank(a);
      const rb = rank(b);
      if (ra !== rb) return ra - rb;
      // Prefer available over out-of-stock at the same rank.
      const va = a.variant.availableForSale ? 0 : 1;
      const vb = b.variant.availableForSale ? 0 : 1;
      return va - vb;
    };
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('quickOrder', () => ({
      // View state
      mode: 'quick-order', // 'quick-order' | 'detail' (detail hides this section, requisition-list-detail renders)
      tab: 'quick-order',  // 'quick-order' | 'lists'
      addingAll: false,

      // Draft (top add-bar) state
      draftQuery: '',
      draftQty: 1,
      draftFlatVariants: [],      // Array<{ product, variant }> — one entry per variant row
      draftSuggestionsOpen: false,
      draftLoading: false,
      draftError: false,
      draftNoResults: false,
      draftHighlight: null,       // { productId, variantId } or null — keyboard focus
      draftAbort: null,           // AbortController for in-flight search
      draftQueryToken: 0,         // increments per search to dedupe stale responses
      // False from the moment a result set is flattened until its buyer-context
      // prices have landed (or failed). The dropdown renders a "-" placeholder
      // in the price column while it's false, so the shopper never sees the
      // public catalogue price get replaced by their contract price a beat
      // later. See applyBuyerPricing.
      draftPricesReady: false,
      searchCache: null,          // Map<query, Product[]>
      // Buyer-context price cache. The GraphQL search runs @inContext(country:)
      // only (no buyer), so it returns PUBLIC catalogue prices — never the
      // B2B/Trade contract price. The same-origin /products/{handle}.js route
      // carries the logged-in buyer's session cookies, so it returns the
      // buyer's contract price exactly like the server-rendered PDP. We source
      // the DISPLAYED price from it and keep GraphQL only for SKU/text
      // discovery. (A Storefront @inContext(buyer:) query would need a customer
      // access token the theme can't mint under new customer accounts.)
      buyerPriceCache: null,      // Map<handle, Map<numericVariantId, {price, compareAtPrice}>>
      buyerPriceInFlight: null,   // Map<handle, Promise> — de-dupes concurrent fetches
      skuHeuristic: null,         // RegExp compiled from config

      // Rows
      rows: [],
      nextRowId: 1,
      // Draft rows survive navigation within the session (sessionStorage,
      // not localStorage) so a shopper can browse the catalog and return to
      // an in-progress order. Cleared once the order is added to the bag.
      rowsStorageKey: 'eck:quick-order:rows',

      // Lists
      lists: [],
      listsLoading: true,
      bridgeUnavailable: false,

      // Labels come from `data-qo-labels`; search config from
      // `data-qo-search-config`. Both hydrated in init().
      companyLocationId: '',
      searchConfig: null,

      handlers: null,

      hydrateLabels() {
        // Labels live on `data-qo-labels`. Shopify's `| t` returns HTML-safe
        // strings — `| json` embeds the entity form, and `| escape` on the
        // attribute wraps that in another entity layer. Browser only decodes
        // one layer on `dataset` read, so we decode remaining entities via a
        // textarea before assigning to state.
        try {
          const raw = this.$root.dataset.qoLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[quick-order] labels JSON parse failed:', err);
        }
        this.companyLocationId = this.$root.dataset.quickOrderCompanyLocationId || '';
        try {
          const raw = this.$root.dataset.qoSearchConfig;
          if (raw) {
            const decoder = document.createElement('textarea');
            decoder.innerHTML = raw;
            this.searchConfig = JSON.parse(decoder.value);
          }
        } catch (err) {
          console.warn('[quick-order] search config JSON parse failed:', err);
        }
        try {
          this.skuHeuristic = new RegExp((this.searchConfig && this.searchConfig.skuHeuristic) || '^[A-Za-z0-9][A-Za-z0-9\\-_/]{2,}$');
        } catch (err) {
          this.skuHeuristic = /^[A-Za-z0-9][A-Za-z0-9\-_/]{2,}$/;
        }
        this.searchCache = new Map();
        this.buyerPriceCache = new Map();
        this.buyerPriceInFlight = new Map();
      },

      resolveMode() {
        const params = new URLSearchParams(window.location.search);
        this.mode = params.get('lid') ? 'detail' : 'quick-order';
        const hash = (window.location.hash || '').replace('#', '');
        if (hash === 'lists') this.tab = 'lists';
        else if (hash === 'quick-order') this.tab = 'quick-order';
      },

      setTab(next) {
        this.tab = next;
        const url = new URL(window.location.href);
        url.hash = next;
        window.history.replaceState({}, '', url);
      },

      itemLabel(count) {
        return count === 1 ? 'item' : 'items';
      },

      // `showCurrency: false` uses `narrowSymbol` so every market's dollar reads
      // as a plain `$`; `true` keeps Intl's market-prefixed symbol (e.g. `NZ$`).
      formatPrice(pr, showCurrency = true) {
        if (typeof pr !== 'number') return '';
        // Market presentment currency from `localization.country.currency`,
        // matching the `@inContext` amounts and storewide display.
        const currency = (this.searchConfig && this.searchConfig.currency)
          || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
          || 'AUD';
        try {
          // Locale pinned to en-AU (not the page locale) so AUD renders `$`,
          // not the `A$` a bare `en` locale produces — as storewide money does.
          return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: currency,
            currencyDisplay: showCurrency ? 'symbol' : 'narrowSymbol',
          }).format(pr);
        } catch (e) { return '$' + pr.toFixed(2); }
      },

      makeRow(seed = {}) {
        return Object.assign({
          id: this.nextRowId++,
          product: null,       // { handle, title, sku, image, variants: [{id, title, price, compare_at, available, quantity_rule}] }
          variantId: '',
          variantPrice: 0,
          variantCompareAt: 0,
          minQty: 1,
          qtyStep: 1,
          maxQty: null,
          qty: 1,
        }, seed);
      },

      addRow(seed) {
        this.rows.push(this.makeRow(seed));
      },

      removeRow(rowId) {
        this.rows = this.rows.filter((r) => r.id !== rowId);
      },

      // Restore any in-progress order left in sessionStorage by a previous
      // page view. nextRowId is recomputed from the restored ids so freshly
      // added rows never collide with a restored one.
      restoreRows() {
        try {
          const raw = sessionStorage.getItem(this.rowsStorageKey);
          if (!raw) return;
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length > 0) {
            this.rows = parsed;
            const maxId = parsed.reduce((m, r) => Math.max(m, Number(r.id) || 0), 0);
            this.nextRowId = maxId + 1;
          }
        } catch (err) {
          console.warn('[quick-order] rows restore failed:', err);
        }
      },

      // Mirror the current rows into sessionStorage. Stringifying the whole
      // array deep-reads every row so the $watch that calls this re-fires on
      // nested changes (qty edits) as well as add / remove.
      persistRows() {
        try {
          sessionStorage.setItem(this.rowsStorageKey, JSON.stringify(this.rows));
        } catch (err) {
          /* Quota / privacy-mode failures are non-fatal — the order just
             won't survive navigation. */
        }
      },

      clearAll() {
        this.rows = [];
        this.resetDraft();
      },

      resetDraft() {
        this.draftQuery = '';
        this.draftFlatVariants = [];
        this.draftPricesReady = false;
        this.draftSuggestionsOpen = false;
        this.draftLoading = false;
        this.draftError = false;
        this.draftNoResults = false;
        this.draftHighlight = null;
        if (this.draftAbort) { try { this.draftAbort.abort(); } catch (e) {} this.draftAbort = null; }
      },

      showDraftSuggestions() {
        if (this.draftQuery && this.draftQuery.length >= (this.searchConfig && this.searchConfig.minQueryLength || 2)) {
          this.draftSuggestionsOpen = true;
        }
      },

      // ─── Storefront GraphQL search ───────────────────────────────────
      //
      //   `predictiveSearch` with an explicit `searchableFields` set: it must
      //   match variant TITLE (a colour like "titanium white" lives on the
      //   variant, not the product title) AND variant SKU/barcode (B2B shoppers
      //   paste SKUs from spreadsheets). The default field set covers title +
      //   variant title but omits SKU/barcode, so those are named explicitly.
      //   quantityRule per variant seeds MOQ without a second round-trip;
      //   results flatten to one row per variant (see applySearchResults()).
      //
      //   `@inContext(country:)` prices in the buyer's market (no token needed).
      //   The B2B contract price needs `@inContext(buyer:)`, which needs a
      //   customer token the theme lacks — so it's enforced at cart/add.
      /* Built per call so the channel metafield alias can be sourced from
         the section config (which reads the provisional key from the
         `variant-channel-hidden` snippet). The alias is omitted when the key
         is unset; querying a metafield with no definition returns null (not an
         error), so a present-but-unmapped key stays fail-open. */
      buildSearchQuery() {
        var channelNs = (this.searchConfig && this.searchConfig.channelNamespace) || '';
        var channelKey = (this.searchConfig && this.searchConfig.channelKey) || '';
        var channelLine =
          channelNs && channelKey
            ? 'shopifyChannel: metafield(namespace: "' + channelNs + '", key: "' + channelKey + '") { value }'
            : '';
        return `
        query QuickOrderSearch($query: String!, $country: CountryCode) @inContext(country: $country) {
          predictiveSearch(
            query: $query
            limit: 10
            types: [PRODUCT]
            unavailableProducts: LAST
            searchableFields: [TITLE, VARIANTS_TITLE, VARIANTS_SKU, VARIANTS_BARCODE, VENDOR, PRODUCT_TYPE]
          ) {
            products {
              id
              title
              handle
              onlineStoreUrl
              featuredImage { url altText }
              variants(first: 250) {
                nodes {
                  id
                  title
                  sku
                  currentlyNotInStock
                  warehouseQuantity: metafield(namespace: "custom", key: "warehouse_inventory_quantity") { value }
                  sellWhenOutOfStock: metafield(namespace: "unifd", key: "sell_when_oos") { value }
                  moqMinimum: metafield(namespace: "unifd", key: "moq_minimum") { value }
                  moqIncrement: metafield(namespace: "unifd", key: "moq_increment") { value }
                  ${channelLine}
                  price { amount }
                  compareAtPrice { amount }
                  quantityRule { minimum increment maximum }
                }
              }
            }
          }
        }
      `;
      },

      /* Stock derived to match `snippets/variant-stock-state.liquid` and the
         checkout validation: `unifd.sell_when_oos` is authoritative (truthy
         never forced OOS), the `custom.warehouse_inventory_quantity` mirror
         wins when it carries a value, and when the mirror hasn't synced we
         fall back to Shopify's own tracked stock via `currentlyNotInStock`.
         Native `availableForSale` is useless here (always true under
         CONTINUE). The derived value keeps the `availableForSale` key so
         every consumer (sort, OOS pills, first-available picks) is unchanged. */
      variantInStock(v) {
        if (this.searchConfig && this.searchConfig.buyerOversells) return true;
        const sellWhenOutOfStock = ((v.sellWhenOutOfStock && v.sellWhenOutOfStock.value) || '')
          .trim()
          .toLowerCase();
        if (sellWhenOutOfStock === 'true' || sellWhenOutOfStock === '1') return true;
        const mirrorRaw = v.warehouseQuantity && v.warehouseQuantity.value;
        if (mirrorRaw != null && String(mirrorRaw).trim() !== '') {
          const mirror = Number(mirrorRaw);
          if (Number.isFinite(mirror)) return mirror > 0;
        }
        /* Mirror not synced - `currentlyNotInStock` is true only for a
           TRACKED variant sitting at zero under a continue-selling policy,
           so untracked variants (which report false) stay sellable. */
        if (v.currentlyNotInStock === true) return false;
        return true;
      },

      /* A variant is hidden from the Online Store channel when its channel
         list is PRESENT and does NOT contain "online" (case-insensitive).
         Mirrors `snippets/variant-channel-hidden.liquid`. The Storefront API
         returns a list.single_line_text_field `value` as a JSON-encoded array
         string (e.g. '["online","pos"]'), so parse it and test membership;
         fall back to a substring test if it isn't parseable. Fail-open: null /
         blank / empty list => visible, so an unmapped metafield hides nothing. */
      variantChannelHidden(v) {
        const raw = v && v.shopifyChannel && v.shopifyChannel.value;
        if (raw == null || String(raw).trim() === '') return false;
        let list = null;
        try {
          list = JSON.parse(raw);
        } catch (e) {
          list = null;
        }
        if (Array.isArray(list)) {
          if (list.length === 0) return false;
          return !list.some((c) => String(c).trim().toLowerCase() === 'online');
        }
        return String(raw).toLowerCase().indexOf('online') === -1;
      },

      /* Resolve the MOQ rule for a Storefront variant node with the SAME
         precedence as the server-rendered PDP (`blocks/product-buy-buttons`)
         and card (`snippets/product-card`): native B2B `quantityRule` wins
         when it carries a real floor (minimum > 1); otherwise fall back to the
         Epicor-fed `unifd.moq_minimum` / `unifd.moq_increment` metafields. An
         increment with no explicit minimum implies the increment IS the floor.
         A non-positive metafield increment is meaningless -> treated as unset.
         Returns `{ minimum, increment, maximum }` so commitVariant / clampQty /
         variantMoqHint enforce it unchanged. */
      resolveVariantMoq(v) {
        const nativeRule = (v && v.quantityRule) || {};
        const nativeMin = Number(nativeRule.minimum);
        if (Number.isFinite(nativeMin) && nativeMin > 1) {
          const nativeStep = Number(nativeRule.increment);
          return {
            minimum: nativeMin,
            increment: Number.isFinite(nativeStep) && nativeStep > 0 ? nativeStep : 1,
            maximum: nativeRule.maximum != null ? Number(nativeRule.maximum) : null,
          };
        }
        const parseMoq = (raw) => {
          if (raw == null || String(raw).trim() === '') return null;
          const n = Number(String(raw).trim());
          return Number.isFinite(n) ? n : null;
        };
        const mfMin = parseMoq(v && v.moqMinimum && v.moqMinimum.value);
        let mfStep = parseMoq(v && v.moqIncrement && v.moqIncrement.value);
        if (mfStep != null && mfStep <= 0) mfStep = null;
        let min = 1;
        let step = 1;
        if (mfMin != null) min = mfMin;
        if (mfStep != null) step = mfStep;
        if (mfMin == null && mfStep != null) min = mfStep;
        return { minimum: min, increment: step, maximum: null };
      },

      /* Resolve the effective upper bound (max orderable quantity) for a
         Storefront variant node, mirroring the server-rendered PDP's
         `effective_max` (`blocks/product-buy-buttons`) and the cap emission
         in `snippets/variant-stock-state`. Returns null (NO cap) when the
         buyer's market oversells, the variant sells when out of stock, or the
         warehouse mirror is blank/absent (untracked / native-count fallback -
         no authoritative sell ceiling) - the same fail-open precedence the
         stock snippet uses to skip a `variant_max_map` entry. Otherwise the
         cap is the warehouse mirror quantity, further lowered to the native
         `quantityRule.maximum` when that is the smaller of the two, then
         GRID-SNAPPED down to the largest valid MOQ step
         (min + floor((cap - min) / increment) * increment) so the ceiling is
         always an orderable quantity, never a value that violates the step.
         `rule` is the resolved MOQ from resolveVariantMoq. */
      resolveVariantMaxQty(v, rule) {
        if (this.searchConfig && this.searchConfig.buyerOversells) return null;
        const sellWhenOutOfStock = ((v && v.sellWhenOutOfStock && v.sellWhenOutOfStock.value) || '')
          .trim()
          .toLowerCase();
        if (sellWhenOutOfStock === 'true' || sellWhenOutOfStock === '1') return null;
        const mirrorRaw = v && v.warehouseQuantity && v.warehouseQuantity.value;
        if (mirrorRaw == null || String(mirrorRaw).trim() === '') return null;
        const mirror = Number(mirrorRaw);
        if (!Number.isFinite(mirror) || mirror <= 0) return null;
        let cap = mirror;
        const nativeMax = rule && rule.maximum != null ? Number(rule.maximum) : null;
        if (nativeMax != null && Number.isFinite(nativeMax) && nativeMax < cap) cap = nativeMax;
        const min = Math.max(1, Number((rule && rule.minimum) || 1));
        const step = Math.max(1, Number((rule && rule.increment) || 1));
        if (cap < min) return null;
        const units = Math.floor((cap - min) / step);
        return min + units * step;
      },

      productFromNode(node) {
        const rawVariants = ((node && node.variants && node.variants.nodes) || [])
          .filter((v) => !this.variantChannelHidden(v));
        const variants = rawVariants.map((v) => {
          const rule = this.resolveVariantMoq(v);
          return {
            id: this.numericIdFromGid(v.id),
            gid: v.id,
            title: v.title,
            sku: v.sku || '',
            availableForSale: this.variantInStock(v),
            price: v.price && v.price.amount != null ? Number(v.price.amount) : null,
            compareAtPrice: v.compareAtPrice && v.compareAtPrice.amount != null ? Number(v.compareAtPrice.amount) : null,
            quantityRule: rule,
            maxQty: this.resolveVariantMaxQty(v, rule),
          };
        });
        return {
          id: this.numericIdFromGid(node.id),
          gid: node.id,
          title: node.title,
          handle: node.handle,
          url: node.onlineStoreUrl || ('/products/' + encodeURIComponent(node.handle)),
          image: (node.featuredImage && node.featuredImage.url) || '',
          variants,
        };
      },

      numericIdFromGid(gid) {
        if (!gid) return null;
        const parts = String(gid).split('/');
        const tail = parts[parts.length - 1];
        const asNum = Number(tail);
        return Number.isFinite(asNum) ? asNum : tail;
      },

      // Fetch (and cache) the buyer-context prices for a product handle from
      // the session `/products/{handle}.js` route — see the buyerPriceCache
      // note above for WHY this beats the @inContext(country:) search price.
      // Returns Map<numericVariantId, {price, compareAtPrice}> or null on
      // failure (callers then fall back to the GraphQL price and never break).
      //
      // UNIT: `.js` `price` / `compare_at_price` are INTEGER CENTS (e.g. 1250),
      // while formatPrice() + variantOnSale() / rowOnSale() work in DECIMAL
      // DOLLARS (matching the GraphQL `price.amount` string and hydrateRow's
      // `Number(v.price) / 100`), so divide the cents by 100 here.
      async fetchBuyerPrices(handle) {
        if (!handle) return null;
        if (this.buyerPriceCache && this.buyerPriceCache.has(handle)) {
          return this.buyerPriceCache.get(handle);
        }
        if (this.buyerPriceInFlight && this.buyerPriceInFlight.has(handle)) {
          return this.buyerPriceInFlight.get(handle);
        }
        const promise = (async () => {
          try {
            const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
              headers: { 'Accept': 'application/json' },
              credentials: 'same-origin',
            });
            if (!res.ok) throw new Error('product_js_http_' + res.status);
            const product = await res.json();
            const map = new Map();
            (product.variants || []).forEach((v) => {
              map.set(Number(v.id), {
                price: v.price != null ? Number(v.price) / 100 : null,
                compareAtPrice: v.compare_at_price != null ? Number(v.compare_at_price) / 100 : null,
              });
            });
            if (this.buyerPriceCache) this.buyerPriceCache.set(handle, map);
            return map;
          } catch (err) {
            console.warn('[quick-order] buyer price fetch failed:', err);
            return null;
          } finally {
            if (this.buyerPriceInFlight) this.buyerPriceInFlight.delete(handle);
          }
        })();
        if (this.buyerPriceInFlight) this.buyerPriceInFlight.set(handle, promise);
        return promise;
      },

      // Overlay buyer-context prices onto the currently displayed variant rows.
      // Mutates the reactive `draftFlatVariants` entries in place so the
      // dropdown re-renders; misses keep the GraphQL price. Guarded by the
      // query token so a stale search's prices never land on newer results.
      //
      // Every handle is resolved BEFORE anything is written, then the whole
      // result set is priced in one pass and `draftPricesReady` flips. Two
      // reasons: the price column shows a "-" until then rather than the
      // public catalogue price (which would visibly change once the contract
      // price arrived), and one batched write means one repaint instead of a
      // price popping per product as each fetch lands.
      //
      // `price` and `compareAtPrice` are always taken as a PAIR from the same
      // source. Keeping a GraphQL compare-at next to a buyer price would strike
      // through a figure the buyer never had, inventing a discount.
      //
      // A failed fetch still flips the flag: the entry keeps its GraphQL price,
      // which is better than a "-" that never resolves.
      async applyBuyerPricing(token) {
        const entries = this.draftFlatVariants;
        const handles = Array.from(
          new Set(entries.map((e) => e.product && e.product.handle).filter(Boolean))
        );

        if (handles.length === 0) {
          if (token === this.draftQueryToken) this.draftPricesReady = true;
          return;
        }

        const maps = new Map();
        await Promise.all(
          handles.map(async (handle) => {
            const map = await this.fetchBuyerPrices(handle);
            if (map) maps.set(handle, map);
          })
        );

        // A newer search has taken over — its own call owns the flag now.
        if (token !== this.draftQueryToken) return;

        entries.forEach((entry) => {
          if (!entry.product) return;
          const map = maps.get(entry.product.handle);
          if (!map) return;
          const priced = map.get(Number(entry.variant.id));
          if (!priced) return;
          if (priced.price != null) entry.variant.price = priced.price;
          entry.variant.compareAtPrice = priced.compareAtPrice;
        });

        this.draftPricesReady = true;
      },

      async searchDraft() {
        const q = String(this.draftQuery || '').trim();
        const minLen = (this.searchConfig && this.searchConfig.minQueryLength) || 2;
        if (q.length < minLen) {
          this.draftFlatVariants = [];
          this.draftSuggestionsOpen = false;
          this.draftError = false;
          this.draftNoResults = false;
          this.draftLoading = false;
          return;
        }

        if (!this.searchConfig || !this.searchConfig.shopDomain || !this.searchConfig.storefrontToken) {
          this.draftError = true;
          this.draftSuggestionsOpen = true;
          return;
        }

        // Cache hit → skip network, re-run mode decision (query may have
        // changed shape between SKU-mode and product-mode without a new
        // fetch being warranted).
        const cached = this.searchCache && this.searchCache.get(q);
        if (cached) {
          // Same abort + token bump as the network path below. The token is the
          // identity of the CURRENTLY DISPLAYED result set, so a cached render
          // has to claim it too: without this a slower in-flight search for an
          // older query still passes the stale guard and overwrites these
          // results, and its applyBuyerPricing would flip draftPricesReady for
          // a set it no longer owns.
          if (this.draftAbort) { try { this.draftAbort.abort(); } catch (e) {} this.draftAbort = null; }
          this.draftQueryToken++;
          this.draftLoading = false;
          this.draftSuggestionsOpen = true;
          this.applySearchResults(q, cached);
          return;
        }

        // Cancel in-flight and bump token so late responses discard.
        if (this.draftAbort) { try { this.draftAbort.abort(); } catch (e) {} }
        const controller = new AbortController();
        this.draftAbort = controller;
        const token = ++this.draftQueryToken;

        this.draftLoading = true;
        this.draftError = false;
        this.draftNoResults = false;
        this.draftSuggestionsOpen = true;

        try {
          const url = 'https://' + this.searchConfig.shopDomain + '/api/' + (this.searchConfig.apiVersion || '2026-07') + '/graphql.json';
          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.searchConfig.storefrontToken,
            },
            body: JSON.stringify({ query: this.buildSearchQuery(), variables: { query: q, country: (this.searchConfig && this.searchConfig.country) || null } }),
            signal: controller.signal,
          });
          if (!res.ok) throw new Error('storefront_http_' + res.status);
          const payload = await res.json();
          if (token !== this.draftQueryToken) return; // stale
          if (payload.errors && payload.errors.length) throw new Error('storefront_graphql_error');
          const products = ((payload.data && payload.data.predictiveSearch && payload.data.predictiveSearch.products) || [])
            .filter((n) => n && n.id) // guard against any null node
            .map((p) => this.productFromNode(p))
            // Drop products left with no variants after channel filtering
            // (e.g. a pos-only product in the B2B catalog) so they read as a
            // clean no-result rather than an empty suggestion row.
            .filter((p) => p.variants.length > 0);
          if (this.searchCache) this.searchCache.set(q, products);
          this.applySearchResults(q, products);
        } catch (err) {
          if (err && err.name === 'AbortError') return;
          console.warn('[quick-order] search failed:', err);
          if (token !== this.draftQueryToken) return;
          this.draftError = true;
          this.draftFlatVariants = [];
        } finally {
          if (token === this.draftQueryToken) this.draftLoading = false;
        }
      },

      // Flatten a raw product list into one entry per variant. Products
      // clone-per-search so nothing leaks between queries.
      //
      //   SKU query with real hits → only the matched variants, best match
      //   first (exact > startsWith > contains, available before OOS).
      //   Otherwise (text query, or SKU-shaped query with zero SKU hits) →
      //   only the variants whose product + variant + SKU text carries every
      //   query token, so "titanium white" lists the titanium-white variants
      //   as their own rows and never the product's unrelated colours. Ranked
      //   available-first, product-then-variant order otherwise preserved. The
      //   filter falls back to every variant when it matches nothing (the query
      //   hit a product on data outside its title), so a genuine result never
      //   collapses to an empty dropdown. SKU-mode is gated by the query shape
      //   (regex) AND by whether any variant SKU actually matches.
      applySearchResults(q, sourceProducts) {
        const products = sourceProducts.map((p) => Object.assign({}, p, {
          variants: p.variants.slice(),
        }));
        this.draftNoResults = products.length === 0;
        this.draftError = false;
        this.draftHighlight = null;
        // Withhold the price column until applyBuyerPricing has run over this
        // result set — the GraphQL prices above are public catalogue only.
        this.draftPricesReady = false;

        if (products.length === 0) {
          this.draftFlatVariants = [];
          this.draftPricesReady = true;
          return;
        }

        const looksLikeSku = this.skuHeuristic && this.skuHeuristic.test(q);
        const skuHits = [];
        if (looksLikeSku) {
          products.forEach((product) => {
            product.variants.forEach((variant) => {
              if (variantMatchesSku(variant, q)) skuHits.push({ product, variant });
            });
          });
        }

        let flat;
        if (skuHits.length > 0) {
          flat = skuHits.sort(skuMatchRank(q));
        } else {
          // Keep only the variants matching every whitespace-delimited query
          // token across the product title, variant title and SKU, so a search
          // narrowed by colour ("titanium white") drops the sibling colours of
          // a matched product rather than listing them all.
          const tokens = q.toLowerCase().split(/\s+/).filter(Boolean);
          const matched = [];
          const everyVariant = [];
          products.forEach((product) => {
            product.variants.forEach((variant) => {
              const entry = { product, variant };
              everyVariant.push(entry);
              const haystack = ((product.title || '') + ' ' + (variant.title || '') + ' ' + (variant.sku || '')).toLowerCase();
              if (tokens.every((t) => haystack.indexOf(t) !== -1)) matched.push(entry);
            });
          });
          // Fall back to every variant when the token filter excludes them all
          // (query matched on data outside the title) so results never vanish.
          flat = matched.length > 0 ? matched : everyVariant;
          // Available variants ahead of out-of-stock ones; stable sort keeps the
          // product-then-variant order within each availability group.
          flat.sort((a, b) => (a.variant.availableForSale ? 0 : 1) - (b.variant.availableForSale ? 0 : 1));
        }
        this.draftFlatVariants = flat;

        // Resolve the buyer's session prices for the freshly-displayed rows.
        // Not awaited — the list paints immediately with names, SKUs and
        // thumbnails, and the price column fills in once (token-guarded, so a
        // stale search never overwrites newer results).
        this.applyBuyerPricing(this.draftQueryToken);

        // Pre-highlight a lone available entry so Enter commits it.
        if (flat.length === 1 && flat[0].variant.availableForSale) {
          this.draftHighlight = { productId: flat[0].product.id, variantId: flat[0].variant.id };
        }
      },

      // A variant title carries no shopper-facing signal when it's the
      // single-variant placeholder Shopify assigns automatically. Matched
      // case-insensitively and trimmed so any casing ("Default Title",
      // "default title") or the SWYM list fallback ("Default") is treated
      // as "no variant" and never surfaces as text.
      isDefaultVariantTitle(title) {
        const t = String(title || '').trim().toLowerCase();
        return t === '' || t === 'default title' || t === 'default';
      },

      // Combined row title: product title plus the variant title when it's a
      // real option (not the single-variant placeholder).
      variantEntryTitle(product, variant) {
        const productTitle = (product && product.title) || '';
        const variantTitle = (variant && variant.title) || '';
        if (!this.isDefaultVariantTitle(variantTitle)) {
          return productTitle + ' ' + variantTitle;
        }
        return productTitle;
      },

      // On sale when a compare-at price sits above the current price — the
      // current price is already the marked-down amount (matches PDP +
      // snippets/price.liquid). NOTE: prices come from `@inContext(country:)`,
      // so B2B-catalog-only prices (which need buyer context) aren't reflected
      // here; a public compare-at markdown is.
      variantOnSale(variant) {
        if (!variant) return false;
        const compareAt = Number(variant.compareAtPrice);
        const price = Number(variant.price);
        return Number.isFinite(compareAt) && Number.isFinite(price) && compareAt > price;
      },

      // Current price for a suggestion-dropdown entry. Holds the same "-"
      // placeholder the table rows use until this result set's buyer-context
      // prices have landed, so the shopper is never shown a public catalogue
      // price that then changes under them. See applyBuyerPricing.
      entryPriceDisplay(entry) {
        if (!this.draftPricesReady) return '-';
        if (!entry || !entry.variant) return '-';
        return this.formatPrice(entry.variant.price, false);
      },

      // Sale state for a dropdown entry. Suppressed until the prices are the
      // buyer's, so a public compare-at never strikes through mid-render.
      entryOnSale(entry) {
        if (!this.draftPricesReady) return false;
        return this.variantOnSale(entry && entry.variant);
      },

      // Compare-at for a dropdown entry, on the same gate as the price above —
      // the pair always renders from one source.
      entryCompareDisplay(entry) {
        if (!this.draftPricesReady) return '';
        if (!entry || !entry.variant) return '';
        return this.formatPrice(entry.variant.compareAtPrice, false);
      },

      // Current price for a resolved table row, or a "-" placeholder for the
      // brief pre-hydration moment before a price lands (rows seed at 0).
      rowPriceDisplay(row) {
        return row && row.variantPrice ? this.formatPrice(row.variantPrice, false) : '-';
      },

      // Sale test for a resolved table row (row-shaped price keys).
      rowOnSale(row) {
        if (!row) return false;
        const compareAt = Number(row.variantCompareAt);
        const price = Number(row.variantPrice);
        return Number.isFinite(compareAt) && Number.isFinite(price) && compareAt > 0 && compareAt > price;
      },

      variantMoqHint(variant) {
        if (!variant || !variant.quantityRule) return '';
        const min = Number(variant.quantityRule.minimum || 1);
        const step = Number(variant.quantityRule.increment || 1);
        const parts = [];
        if (min > 1) parts.push((this.moqHintTemplate || 'Min. __MIN__').replace('__MIN__', min));
        if (step > 1) parts.push((this.moqStepHintTemplate || '×__STEP__').replace('__STEP__', step));
        return parts.join(' · ');
      },

      isHighlighted(productId, variantId) {
        const h = this.draftHighlight;
        return !!(h && h.productId === productId && h.variantId === variantId);
      },

      // Selectable {productId, variantId} pairs in DOM order — the available
      // entries of the flat variant list.
      selectableSequence() {
        return this.draftFlatVariants
          .filter((e) => e.variant.availableForSale)
          .map((e) => ({ productId: e.product.id, variantId: e.variant.id }));
      },

      moveHighlight(direction) {
        if (!this.draftSuggestionsOpen) {
          this.draftSuggestionsOpen = true;
        }
        const seq = this.selectableSequence();
        if (seq.length === 0) return;
        const currentIdx = this.draftHighlight
          ? seq.findIndex((s) => s.productId === this.draftHighlight.productId && s.variantId === this.draftHighlight.variantId)
          : -1;
        let nextIdx = currentIdx + direction;
        if (nextIdx < 0) nextIdx = seq.length - 1;
        if (nextIdx >= seq.length) nextIdx = 0;
        this.draftHighlight = seq[nextIdx];
      },

      // ─── Selection & commit ─────────────────────────────────────────

      commitDraft() {
        // Enter-key path: prefer the highlighted entry, else the first
        // available entry of the flat variant list.
        if (this.draftHighlight) {
          const found = this.findVariant(this.draftHighlight.productId, this.draftHighlight.variantId);
          if (found) return this.commitVariant(found.product, found.variant);
        }
        if (this.draftFlatVariants.length > 0) {
          const first = this.draftFlatVariants.find((e) => e.variant.availableForSale) || this.draftFlatVariants[0];
          return this.commitVariant(first.product, first.variant);
        }
      },

      findVariant(productId, variantId) {
        return this.draftFlatVariants.find((e) => e.product.id === productId && e.variant.id === variantId) || null;
      },

      async commitVariant(product, variant) {
        if (!product || !variant || !variant.availableForSale) return;
        const rule = variant.quantityRule || {};
        const min = Math.max(1, Number(rule.minimum || 1));
        const step = Math.max(1, Number(rule.increment || 1));
        /* Effective cap = the grid-snapped upper bound resolved at map time
           (warehouse mirror, lowered to the native max, PDP-snapped), NOT the
           raw native `quantityRule.maximum`. null = uncapped (oversell /
           sell-when-oos / untracked). clampQty enforces it on the seed qty. */
        const max = variant.maxQty != null ? Number(variant.maxQty) : null;
        const seedQty = Math.max(min, Number(this.draftQty) || 1);

        // Resolve the buyer-context price for this handle before building the
        // row. `.js` carries the session/buyer prices (the GraphQL search only
        // knows the public catalogue price); a null map falls back to the
        // GraphQL price so a row is never blocked. See fetchBuyerPrices.
        const priceMap = await this.fetchBuyerPrices(product.handle);
        const buyerPrice = (id) => (priceMap ? priceMap.get(Number(id)) : null) || null;
        const committed = buyerPrice(variant.id);
        const rowPrice = committed && committed.price != null ? committed.price : (variant.price || 0);
        const rowCompareAt = committed ? committed.compareAtPrice : variant.compareAtPrice;

        const row = this.makeRow({
          qty: seedQty,
          minQty: min,
          qtyStep: step,
          maxQty: max,
          variantId: variant.id,
          variantPrice: rowPrice || 0,
          variantCompareAt: rowCompareAt || 0,
          product: {
            id: product.id,
            handle: product.handle,
            title: product.title,
            image: product.image,
            sku: variant.sku || '',
            variants: product.variants.map((v) => {
              const priced = buyerPrice(v.id);
              return {
                id: v.id,
                title: v.title,
                sku: v.sku,
                price: priced && priced.price != null ? priced.price : v.price,
                compare_at: priced ? priced.compareAtPrice : v.compareAtPrice,
                available: v.availableForSale,
                quantity_rule: v.quantityRule
                  ? { min: v.quantityRule.minimum, increment: v.quantityRule.increment, max: v.maxQty != null ? v.maxQty : null }
                  : null,
              };
            }),
          },
        });
        // Clamp to step in case the shopper typed a qty like `3` when step=2.
        this.clampQty(row);
        this.rows.push(row);
        this.resetDraft();
        this.draftQty = 1;
      },

      clearDraft() {
        this.resetDraft();
        const input = this.$root.querySelector('#quick-order-search');
        if (input) input.focus();
      },

      incrementDraftQty() {
        this.draftQty = Math.max(1, Number(this.draftQty) || 1) + 1;
      },
      decrementDraftQty() {
        this.draftQty = Math.max(1, (Number(this.draftQty) || 1) - 1);
      },
      clampDraftQty() {
        this.draftQty = Math.max(1, Number(this.draftQty) || 1);
      },

      async hydrateRow(row, hit) {
        try {
          const res = await fetch('/products/' + encodeURIComponent(hit.handle) + '.js');
          const product = await res.json();
          row.product = {
            id: product.id,
            handle: product.handle,
            title: product.title,
            image: hit.image || product.featured_image || (product.images && product.images[0]) || '',
            sku: hit.sku || (product.variants && product.variants[0] && product.variants[0].sku) || '',
            /* `/products/{handle}.js` `available` is always true under
               native CONTINUE. When the hit came from the Storefront
               search (which carries the metafield-derived flag), map
               availability across by variant id; otherwise fail open. */
            variants: (product.variants || []).map((v) => {
              const hitVariant = (hit && hit.variants || []).find(
                (hv) => String(hv.id) === String(v.id)
              );
              return {
                id: v.id,
                title: v.title,
                sku: v.sku,
                price: (v.price != null) ? Number(v.price) / 100 : null,
                compare_at: (v.compare_at_price != null) ? Number(v.compare_at_price) / 100 : null,
                available: hitVariant ? !!hitVariant.availableForSale : true,
                quantity_rule: v.quantity_rule || null,
              };
            }),
          };
          const firstAvailable = row.product.variants.find((v) => v.available) || row.product.variants[0];
          if (firstAvailable) {
            row.variantId = firstAvailable.id;
            this.onVariantChange(row);
          }
        } catch (e) {
          console.warn('[quick-order] product fetch failed:', e);
        }
      },

      // Legacy per-row selectProduct — kept for loadIntoQuickOrder + external hydration.
      async selectProduct(row, hit) {
        await this.hydrateRow(row, hit);
      },

      onVariantChange(row) {
        if (!row.product || !row.variantId) return;
        const variant = row.product.variants.find((v) => v.id === Number(row.variantId));
        if (!variant) return;
        row.variantPrice = variant.price || 0;
        row.variantCompareAt = variant.compare_at || 0;
        row.product.sku = variant.sku || row.product.sku;
        const rule = variant.quantity_rule || {};
        row.minQty = Number(rule.min || 1);
        row.qtyStep = Number(rule.increment || 1);
        row.maxQty = rule.max != null ? Number(rule.max) : null;
        if (row.qty < row.minQty) row.qty = row.minQty;
        this.clampQty(row);
      },

      clampQty(row) {
        const min = row.minQty || 1;
        const step = row.qtyStep || 1;
        const max = row.maxQty != null ? Number(row.maxQty) : null;
        let q = Number(row.qty || 0);
        if (q < min) q = min;
        const remainder = (q - min) % step;
        if (remainder !== 0) q = q + (step - remainder);
        if (max != null && q > max) {
          const overflow = (q - min) % step;
          q = max - overflow;
          if (q < min) q = min;
        }
        row.qty = q;
      },

      incrementQty(row) {
        row.qty = Number(row.qty || 0) + Number(row.qtyStep || 1);
        this.clampQty(row);
      },

      decrementQty(row) {
        const step = Number(row.qtyStep || 1);
        const min = Number(row.minQty || 1);
        const next = Number(row.qty || 0) - step;
        row.qty = next < min ? min : next;
      },

      get hasResolvedRows() {
        return this.rows.some((r) => r.variantId && r.qty > 0);
      },

      get grandTotal() {
        return this.rows.reduce((sum, r) => sum + (Number(r.variantPrice) || 0) * (Number(r.qty) || 0), 0);
      },

      async addAllToCart() {
        if (this.addingAll || !this.hasResolvedRows) return;
        /* Skip rows whose resolved variant is out of stock (mirror +
           sell_when_oos + native fallback via `variantInStock`), so an OOS
           line can't be pushed to the cart. */
        const skippedIds = new Set();
        const items = [];
        this.rows.forEach((r) => {
          if (!(r.variantId && r.qty > 0)) return;
          const variant = r.product && Array.isArray(r.product.variants)
            ? r.product.variants.find((v) => v.id === Number(r.variantId))
            : null;
          if (variant && variant.availableForSale === false) {
            skippedIds.add(Number(r.variantId));
            return;
          }
          items.push({ id: Number(r.variantId), quantity: Number(r.qty) });
        });
        const skipped = skippedIds.size;
        if (items.length === 0) {
          if (skipped > 0) this.notifyOosSkipped(skipped, true);
          return;
        }
        this.addingAll = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('cart-add failed');
          const payload = await res.json();
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { item: (payload.items && payload.items[0]) || payload }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          /* Clear added rows; keep any out-of-stock rows so the shopper sees
             what wasn't added. */
          if (skipped > 0) {
            this.rows = this.rows.filter((r) => skippedIds.has(Number(r.variantId)));
            this.notifyOosSkipped(skipped, false);
          } else {
            this.rows = [];
          }
        } catch (err) {
          console.warn('[quick-order] add-all-to-cart failed:', err);
        } finally {
          this.addingAll = false;
        }
      },
      /* Surface skipped out-of-stock items through the shared cart-add error
         toast (`cart:add:error` -> snippets/cart-add-error-toast.liquid). */
      notifyOosSkipped(count, allSkipped) {
        const template = allSkipped ? this.oosAllSkippedLabel : this.oosSomeSkippedLabel;
        const message = String(template || '').replace('__COUNT__', count);
        document.dispatchEvent(new CustomEvent('cart:add:error', {
          detail: { error: { body: { message } }, tone: 'warning' },
          bubbles: true,
        }));
      },

      openSaveDrawer() {
        const items = this.rows
          .filter((r) => r.variantId && r.qty > 0 && r.product)
          .map((r) => {
            const variant = r.product.variants.find((v) => v.id === Number(r.variantId));
            return {
              variantId: Number(r.variantId),
              productId: Number(r.product.id || 0),
              url: window.location.origin + '/products/' + r.product.handle,
              qty: Number(r.qty),
              // Best-effort metadata for the toast.
              title: r.product.title,
              variantTitle: variant && variant.title,
              price: variant && variant.price,
            };
          });
        document.dispatchEvent(new CustomEvent('wishlist:open-save-drawer', {
          detail: { items },
          bubbles: true,
        }));
      },

      openCreate() {
        document.dispatchEvent(new CustomEvent('wishlist:open-create', { detail: {}, bubbles: true }));
      },

      navigateToDetail(lid) {
        const url = '/pages/quick-order?lid=' + encodeURIComponent(lid);
        window.history.pushState({}, '', url);
        this.resolveMode();
        window.dispatchEvent(new PopStateEvent('popstate'));
      },

      async loadIntoQuickOrder(list) {
        try {
          const fetched = await window.EckList.getList(list.lid);
          const items = (fetched && Array.isArray(fetched.listcontents)) ? fetched.listcontents : [];
          if (items.length === 0) return;
          // Reset then hydrate: each item becomes a resolved row with the
          // variant + quantity from the list. Product metadata is fetched
          // lazily on the first interaction (variant dropdown click).
          this.rows = items.map((it) => this.makeRow({
            product: {
              handle: (it.du || '').split('/products/').pop() || '',
              title: it.dt || '',
              id: it.empi,
              image: it.iu || '',
              sku: '',
              variants: [{
                id: Number(it.epi),
                title: it.vi || 'Default',
                sku: '',
                price: Number(it.pr) || 0,
                available: true,
                quantity_rule: null,
              }],
            },
            variantId: Number(it.epi),
            variantPrice: Number(it.pr) || 0,
            qty: Number(it.qty) || 1,
          }));
          this.setTab('quick-order');
        } catch (err) {
          console.warn('[quick-order] load-into-quick-order failed:', err);
        }
      },

      async hydrateLists() {
        if (this.bridgeUnavailable) { this.listsLoading = false; return; }
        this.listsLoading = true;
        try {
          const raw = await window.EckList.getLists();
          this.lists = (raw || []).map((l) => ({
            lid: l.lid,
            lname: l.lname,
            cnt: l.cnt || (Array.isArray(l.listcontents) ? l.listcontents.length : 0),
            uts: l.uts || l.cts || null,
            listcontents: Array.isArray(l.listcontents) ? l.listcontents : [],
            addingToBag: false,
          }));
        } catch (err) {
          this.lists = [];
        } finally {
          this.listsLoading = false;
        }
      },

      formatListDate(uts) {
        if (!uts) return '';
        // SWYM `uts` is milliseconds since epoch.
        const d = new Date(Number(uts));
        if (isNaN(d.getTime())) return '';
        try {
          return new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU', {
            day: 'numeric', month: 'short', year: 'numeric',
          }).format(d);
        } catch (e) { return ''; }
      },

      async addListToBag(list) {
        if (!list || list.addingToBag) return;
        const raw = (list.listcontents || [])
          .map((it) => ({ id: Number(it.epi), quantity: Number(it.qty || 1) }))
          .filter((x) => x.id);
        if (raw.length === 0) return;
        list.addingToBag = true;
        try {
          /* Saved-list contents carry no stock data, so resolve each variant
             against the Storefront API and drop the out-of-stock ones before
             the add. Fails open (adds everything) if the lookup can't run. */
          const oosIds = await this.resolveOosVariantIds(raw.map((x) => x.id));
          const items = raw.filter((x) => !oosIds.has(x.id));
          const skipped = raw.length - items.length;
          if (items.length === 0) {
            this.notifyOosSkipped(skipped, true);
            return;
          }
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('cart-add failed');
          const payload = await res.json();
          document.dispatchEvent(new CustomEvent('cart:add', {
            detail: { item: (payload.items && payload.items[0]) || payload },
            bubbles: true,
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (skipped > 0) this.notifyOosSkipped(skipped, false);
        } catch (err) {
          console.warn('[quick-order-lists] add-all-to-bag failed:', err);
        } finally {
          list.addingToBag = false;
        }
      },
      /* Resolve out-of-stock variant ids for a batch of variant ids via the
         Storefront API, reusing `variantInStock`. Returns a Set of numeric
         ids; fails open (empty Set) on any error or missing config. */
      async resolveOosVariantIds(numericIds) {
        const oos = new Set();
        if (!this.searchConfig || !this.searchConfig.shopDomain || !this.searchConfig.storefrontToken) return oos;
        const ids = Array.from(new Set((numericIds || []).filter(Boolean)));
        if (ids.length === 0) return oos;
        const gids = ids.map((id) => 'gid://shopify/ProductVariant/' + id);
        const query = `
          query variantStock($ids: [ID!]!) {
            nodes(ids: $ids) {
              ... on ProductVariant {
                id
                currentlyNotInStock
                warehouseQuantity: metafield(namespace: "custom", key: "warehouse_inventory_quantity") { value }
                sellWhenOutOfStock: metafield(namespace: "unifd", key: "sell_when_oos") { value }
              }
            }
          }
        `;
        try {
          const url = 'https://' + this.searchConfig.shopDomain + '/api/' + (this.searchConfig.apiVersion || '2026-07') + '/graphql.json';
          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.searchConfig.storefrontToken,
            },
            body: JSON.stringify({ query, variables: { ids: gids } }),
          });
          if (!res.ok) return oos;
          const payload = await res.json();
          const nodes = (payload.data && payload.data.nodes) || [];
          nodes.forEach((n) => {
            if (!n || !n.id) return;
            if (!this.variantInStock(n)) oos.add(this.numericIdFromGid(n.id));
          });
        } catch (err) {
          console.warn('[quick-order] stock resolve failed:', err);
        }
        return oos;
      },

      init() {
        this.hydrateLabels();
        this.resolveMode();
        // Rehydrate any in-progress order from a previous page view, then
        // mirror every subsequent change back to sessionStorage. The
        // `JSON.stringify(rows)` watch expression deep-reads the rows so the
        // watcher re-fires on nested qty edits, not only add / remove.
        this.restoreRows();
        this.$watch('JSON.stringify(rows)', () => this.persistRows());
        // Rows are added via the top add-bar or via loadIntoQuickOrder.
        const onReady = () => this.hydrateLists();
        const onListsChanged = () => this.hydrateLists();
        const onDegraded = () => {
          this.bridgeUnavailable = true;
          this.listsLoading = false;
          this.lists = [];
        };
        const onLoadList = (event) => {
          const lid = event && event.detail && event.detail.lid;
          if (lid) this.loadIntoQuickOrder({ lid });
        };
        const onPopState = () => this.resolveMode();
        if (window.EckList && window.EckList.mode === 'ready') onReady();
        if (window.EckList && window.EckList.mode === 'degraded') onDegraded();
        document.addEventListener('swym:ready', onReady);
        document.addEventListener('swym:lists-changed', onListsChanged);
        document.addEventListener('swym:degraded', onDegraded);
        document.addEventListener('quick-order:load-list', onLoadList);
        window.addEventListener('popstate', onPopState);
        this.handlers = { onReady, onListsChanged, onDegraded, onLoadList, onPopState };
      },

      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('swym:ready', this.handlers.onReady);
        document.removeEventListener('swym:lists-changed', this.handlers.onListsChanged);
        document.removeEventListener('swym:degraded', this.handlers.onDegraded);
        document.removeEventListener('quick-order:load-list', this.handlers.onLoadList);
        window.removeEventListener('popstate', this.handlers.onPopState);
        this.handlers = null;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  /**
   * Search-results tab wiring.
   *
   * The Products count is server-rendered from `search.results_count` (the
   * filter-aware total) and re-rendered by plp.js on every swap.
   *
   * Articles/Pages don't respond to product filters, so their totals are
   * fetched once per query from the lightweight `search-count` section (no
   * results payload) and cached; they're never re-fetched on filter/sort.
   *
   * `plp:updated` (dispatched by plp.js after a filter/sort swap) triggers a
   * cheap DOM-only re-sync — no requests.
   */
  (function () {
    const section = document.querySelector('[data-search-section]');
    if (!section) return;

    const rawQuery = () => (section.dataset.searchQuery || '').trim();
    const filtersActive = () =>
      [...new URLSearchParams(window.location.search).keys()].some((k) => k.startsWith('filter.'));
    const tab = (value) => section.querySelector(`.search-section__tab-group [data-tab-value="${value}"]`);
    const setBadge = (value, n) => {
      const el = tab(value)?.querySelector('.tab-item__count');
      if (el) el.textContent = '[' + n + ']';
    };

    let secondaryCounts = null; // { articles, pages } — stable per query
    const cellsLoaded = { articles: false, pages: false };

    async function fetchCount(type) {
      try {
        const url = '/search?q=' + encodeURIComponent(rawQuery()) + '&type=' + type + '&section_id=search-count';
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) return 0;
        const m = (await res.text()).match(/data-search-total="(\d+)"/);
        return m ? parseInt(m[1], 10) : 0;
      } catch (_) {
        return 0;
      }
    }

    /* Mirror the server-rendered (swap-refreshed) products total onto the tab. */
    function syncProductsBadge() {
      const el = section.querySelector('[data-plp-products-count]');
      const n = el ? parseInt(el.dataset.count, 10) : NaN;
      if (Number.isFinite(n)) setBadge('products', n);
    }

    function syncSecondaryTabs() {
      const filtered = filtersActive();
      ['articles', 'pages'].forEach((value) => {
        const t = tab(value);
        if (!t) return;
        if (filtered) { t.hidden = true; return; }
        if (secondaryCounts) {
          setBadge(value, secondaryCounts[value]);
          t.hidden = secondaryCounts[value] <= 0;
        }
        /* else: leave the server-rendered visibility until counts land */
      });
      /* If the active tab is now hidden (filters just applied), fall back. */
      const active = section.querySelector('.search-section__tab-group [aria-selected="true"]');
      if (active && active.hidden) tab('products')?.click();
    }

    async function loadSecondaryCounts() {
      if (secondaryCounts || filtersActive()) return; // once, unfiltered only
      const key = 'search-counts:' + rawQuery().toLowerCase();
      try {
        const cached = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (cached) { secondaryCounts = cached; syncSecondaryTabs(); return; }
      } catch (_) {}
      const [articles, pages] = await Promise.all([fetchCount('article'), fetchCount('page')]);
      secondaryCounts = { articles, pages };
      try { sessionStorage.setItem(key, JSON.stringify(secondaryCounts)); } catch (_) {}
      syncSecondaryTabs();
    }

    /* Lazy-load a panel's full result set the first time its tab opens — but
       only if the server slice is short of the true total. */
    async function loadCells(type) {
      const which = type === 'article' ? 'articles' : 'pages';
      if (cellsLoaded[which] || filtersActive()) return;
      const grid = section.querySelector(which === 'articles' ? '[data-articles-grid]' : '[data-pages-list]');
      if (!grid) return;
      const total = secondaryCounts ? secondaryCounts[which] : Infinity;
      if (grid.children.length >= total) { cellsLoaded[which] = true; return; }
      cellsLoaded[which] = true;
      const empty = section.querySelector(which === 'articles' ? '[data-articles-empty]' : '[data-pages-empty]');
      const cellSel = which === 'articles' ? '.search-section__article-cell' : '.search-section__page-cell';
      try {
        const res = await fetch('/search?q=' + encodeURIComponent(rawQuery()) + '&type=' + type, { headers: { Accept: 'text/html' } });
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const html = Array.from(doc.querySelectorAll(cellSel)).map((c) => c.outerHTML).join('');
        if (html) {
          grid.innerHTML = html;
          grid.hidden = false;
          if (empty) empty.hidden = true;
        }
      } catch (_) {}
    }

    section.addEventListener('click', (event) => {
      const t = event.target.closest('.search-section__tab-group [data-tab-value]');
      if (!t) return;
      if (t.dataset.tabValue === 'articles') loadCells('article');
      else if (t.dataset.tabValue === 'pages') loadCells('page');
    });

    function run() {
      if (!rawQuery()) return;
      syncProductsBadge();
      syncSecondaryTabs();
      loadSecondaryCounts();
    }

    run();
    /* Filter/sort swaps: DOM-only re-sync, no requests. */
    document.addEventListener('plp:updated', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopable-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('shopableImage', () => ({
      order: [],
      activeIndex: 0,
      init() {
        this.hoistPins();
        const products = this.$root.querySelectorAll('[data-shopable-product]');
        this.order = Array.from(products).map((el) => el.dataset.shopableProduct);
        this.$root.querySelectorAll('[data-shopable-pin]').forEach((pin) => {
          pin.addEventListener('click', () => this.setActiveById(pin.dataset.shopablePinTarget));
        });
        this.$watch('activeIndex', () => this.apply());
        this.apply();
      },
      hoistPins() {
        const container = this.$root.querySelector('[data-shopable-pins]');
        if (!container) return;
        this.$root.querySelectorAll('.shopable__products-track [data-shopable-pin]').forEach((pin) => {
          container.appendChild(pin);
        });
      },
      apply() {
        const id = this.order[this.activeIndex];
        this.$root.querySelectorAll('[data-shopable-pin]').forEach((pin) => {
          pin.setAttribute('aria-pressed', pin.dataset.shopablePinTarget === id ? 'true' : 'false');
        });
        this.$root.querySelectorAll('[data-shopable-product]').forEach((product) => {
          if (product.dataset.shopableProduct === id) product.setAttribute('data-active', '');
          else product.removeAttribute('data-active');
        });
      },
      setActiveById(id) {
        const i = this.order.indexOf(id);
        if (i !== -1) this.activeIndex = i;
      },
      step(delta) {
        if (!this.order.length) return;
        this.activeIndex = (this.activeIndex + delta + this.order.length) % this.order.length;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-create-modal"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistCreate', () => ({
      name: '',
      error: '',
      submitting: false,
      context: null,
      // Labels hydrated from `data-wl-create-labels` on the root in init().
      handlers: null,
      get counterText() {
        return (this.counterTemplate || '').replace('__COUNT__', (this.name.length || 0));
      },
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.wlCreateLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[wishlist-create] labels JSON parse failed:', err);
        }
      },
      syncSubmitLabel() {
        // The submit button is rendered by the shared `button` snippet which
        // outputs a <span class="button__label"> child. Mirror the current
        // label state (Create / Creating...) and disabled state onto that
        // node instead of duplicating the button markup.
        const button = this.$root.querySelector('.wishlist-create__submit');
        if (!button) return;
        const labelEl = button.querySelector('.button__label');
        const label = this.submitting ? this.submittingLabel : this.submitLabel;
        if (labelEl && labelEl.textContent !== label) labelEl.textContent = label;
        const trimmed = String(this.name || '').trim();
        const invalid = this.submitting || trimmed.length < 3 || trimmed.length > 50;
        if (invalid) {
          button.setAttribute('disabled', '');
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        }
      },
      open(event) {
        const detail = (event && event.detail) || {};
        this.context = {
          variantId: detail.variantId ? Number(detail.variantId) : null,
          productId: detail.productId ? Number(detail.productId) : null,
          url: detail.url || '',
          followupItems: Array.isArray(detail.followupItems) ? detail.followupItems : [],
        };
        this.name = detail.prefillName ? String(detail.prefillName).slice(0, 50) : '';
        this.error = '';
        this.submitting = false;
        const dialog = document.getElementById('wishlist-create-drawer');
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        } else {
          dialog.setAttribute('open', '');
        }
        // Focus the input after the drawer transition settles.
        setTimeout(() => {
          if (this.$refs && this.$refs.input) this.$refs.input.focus();
        }, 100);
      },
      close() {
        const dialog = document.getElementById('wishlist-create-drawer');
        if (dialog && typeof dialog.close === 'function') dialog.close();
      },
      async submit() {
        const trimmed = String(this.name || '').trim();
        if (trimmed.length < 3) { this.error = this.errorShort; return; }
        if (trimmed.length > 50) { this.error = this.errorLong; return; }
        this.error = '';
        this.submitting = true;
        try {
          const list = await window.EckList.createList({ name: trimmed });
          const ctx = this.context || {};
          const hasProduct = ctx.variantId && ctx.productId && ctx.url;
          const followups = Array.isArray(ctx.followupItems) ? ctx.followupItems : [];
          if (list && list.lid) {
            let addedCount = 0;
            if (hasProduct) {
              const primary = await window.EckList.addProduct(list.lid, ctx).catch(() => null);
              if (primary) addedCount++;
            }
            for (const item of followups) {
              try {
                await window.EckList.addProduct(list.lid, item);
                addedCount++;
              } catch (e) { /* Swym silently dedupes; skip individual failures */ }
            }
            if (addedCount > 0) {
              document.dispatchEvent(new CustomEvent('wishlist:toast', {
                detail: {
                  lid: list.lid,
                  lname: list.lname,
                  kind: 'added',
                  item: addedCount === 1 && hasProduct
                    ? { dt: null, du: ctx.url, epi: ctx.variantId, empi: ctx.productId }
                    : { dt: addedCount + ' item' + (addedCount === 1 ? '' : 's') },
                },
                bubbles: true,
              }));
            } else {
              document.dispatchEvent(new CustomEvent('wishlist:created', {
                detail: { lid: list.lid, lname: list.lname },
                bubbles: true,
              }));
            }
          }
          this.close();
        } catch (err) {
          console.warn('[wishlist-create] create failed:', err);
          this.error = this.errorGeneric;
        } finally {
          this.submitting = false;
        }
      },
      init() {
        this.hydrateLabels();
        this.syncSubmitLabel();
        this.$watch('name', () => this.syncSubmitLabel());
        this.$watch('submitting', () => this.syncSubmitLabel());
        const onOpen = (event) => this.open(event);
        document.addEventListener('wishlist:open-create', onOpen);
        this.handlers = { onOpen };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('wishlist:open-create', this.handlers.onOpen);
        this.handlers = null;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-detail"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistDetail', () => ({
      mode: 'landing',
      lid: null,
      shareHash: null,
      list: null,
      loading: true,
      fetchError: null,
      unavailable: false,
      addingAll: false,
      // B2B / EDU requisition quantities, keyed on numeric variant id (epi).
      // Seeded from the Swym item's stored `qty` (what quick order / the
      // save drawer wrote when the line was saved), updated by the per-card
      // quantity selectors (`quantity:change`), persisted back to Swym by
      // `persistQty`, and read by addAllToBag(). Empty for B2C — those cards
      // render the per-card quick-add CTA instead and add a single unit.
      quantities: {},
      // Per-epi debounce handles for the Swym write-back, so holding the
      // stepper fires one update rather than one per click.
      qtyWriteTimers: null,
      // Guest bare-URL mode — server-rendered flag on the section root
      // captured on init. Controls whether the "your wishlist is empty"
      // block replaces the standard chrome for guests with 0 items.
      isGuestDefault: false,
      // Labels + search config come from data-* attrs on the section
      // root — hydrated in init(). See hydrateLabels().
      searchConfig: null,
      // Product hydration: Map<empi, hydratedProduct> keyed on numeric
      // product id. Filled by hydrateProducts() after a Swym fetch.
      productsById: {},
      productsLoading: false,
      productsError: false,
      // Buyer-context price overlay (B2B/Trade only). The Storefront
      // hydration runs @inContext(country:) only, so `productsById` carries
      // PUBLIC catalogue prices — never the buyer's contract price. For B2B
      // customers we re-source the DISPLAYED price from the same-origin
      // `/products/{handle}.js` route (which runs in the logged-in session
      // and returns the contract price like the server-rendered PDP) and
      // overlay it here, keyed by numeric variant id. `cardFor()` reads this
      // reactively so cards + print rows re-render as each handle resolves.
      // Empty for B2C / guests — no fetch, no behaviour change. Fail-open:
      // a miss or fetch failure keeps the storefront price.
      buyerPrices: {},
      buyerPriceCache: null,      // Map<handle, Map<numericVariantId, {price, compareAtPrice}>>
      buyerPriceInFlight: null,   // Map<handle, Promise> — de-dupes concurrent fetches
      // Flips true once hydrateProducts() has *completed* an attempt
      // (success, failure, or early-return). Gates the "Add all to bag"
      // button so a click can't land before the warehouse-mirror stock
      // signals in `productsById` are ready — otherwise `cardFor()` returns
      // the un-hydrated `available: true` fallback and OOS items slip past
      // the skip. Fail-open: a genuine hydration failure still flips this
      // true so the button re-enables and OOS falls through to the
      // checkout Function.
      productsHydrated: false,
      // In-flight hydrateProducts() promise, awaited at the top of
      // addAllToBag() as a belt-and-braces guard against an early click.
      _productsHydration: null,
      justCopied: false,
      copiedTimer: null,
      handlers: null,
      // List contents with deleted / deactivated products AND unavailable
      // pinned variants pruned out. Two independent signals from the same
      // Storefront hydration:
      //
      //   Product level — a product removed, archived, drafted or unpublished
      //   from the store comes back as a null node, so it's absent from
      //   `productsById`; drop it so the wishlist never renders a broken tile
      //   linking to a dead PDP.
      //
      //   Variant level (deletion) — a pinned variant (`epi`) absent from the
      //   parent's `variants.nodes` is deleted/unpublished. B2C drops it (the
      //   public token IS the online catalogue); B2B keeps it (that token can't
      //   see the buyer's catalogue, so absence isn't a reliable signal).
      //
      //   Channel level — a pinned variant PRESENT but channel-hidden is
      //   dropped for BOTH buyer types via `variantChannelHidden` (client twin
      //   of `snippets/variant-channel-hidden.liquid`). Only runs once the
      //   channel alias is queried, so an unmapped key hides nothing.
      //
      // Fail open in every uncertain state — hydration still running, the fetch
      // errored, no token, or the token returned nothing at all (a scoping
      // issue, not a per-product deletion) — so valid items, including
      // B2B-catalogue products the Storefront token can't see, are never hidden.
      get visibleContents() {
        const all = this.dedupeByEpi(
          this.list && Array.isArray(this.list.listcontents) ? this.list.listcontents : []
        );
        if (!this.productsHydrated || this.productsError) return all;
        if (!this.searchConfig || !this.searchConfig.storefrontToken) return all;
        if (Object.keys(this.productsById).length === 0) return all;
        const isB2B = !!(this.searchConfig && this.searchConfig.isB2B);
        const channelConfigured = !!(this.searchConfig && this.searchConfig.channelNamespace && this.searchConfig.channelKey);
        return all.filter((it) => {
          const empi = Number(it && it.empi);
          if (!empi) return true;
          const product = this.productsById[empi];
          if (!product) return false;
          const epi = Number(it && it.epi);
          if (!epi) return true;
          const variants = (product.variants && product.variants.nodes) || [];
          const variantNode = variants.find((v) => this.numericIdFromGid(v.id) === epi);

          // Channel prune (both buyer types). Gated on `channelConfigured` so
          // an unmapped key never fails a B2B item closed on unfetched data.
          if (channelConfigured && variantNode && this.variantChannelHidden(variantNode, product)) {
            return false;
          }

          // Deleted-variant prune (B2C / guest only; B2B fails open — see getter doc).
          if (isB2B) return true;
          return !!variantNode;
        });
      },

      /* Both grids key their `x-for` on `epi`, and Alpine's list renderer
         throws on a duplicate key ("Cannot read properties of undefined
         (reading 'after')") — which takes the entire list down, not just the
         offending tile. The bridge no longer lets a duplicate into the cache,
         but a list is shared state written by several surfaces, so collapse
         defensively here too: a render crash is a far worse failure than a
         line silently appearing once. Last write wins, which matches the
         bridge's replace-on-add. */
      dedupeByEpi(items) {
        const seen = new Map();
        items.forEach((it) => {
          const epi = Number(it && it.epi);
          if (!epi) return;
          seen.set(epi, seen.has(epi) ? Object.assign({}, seen.get(epi), it) : it);
        });
        return Array.from(seen.values());
      },
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.wlDetailLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[wishlist-detail] labels JSON parse failed:', err);
        }
        try {
          const raw = this.$root.dataset.wlDetailSearchConfig;
          if (raw) {
            const decoder = document.createElement('textarea');
            decoder.innerHTML = raw;
            this.searchConfig = JSON.parse(decoder.value);
          }
        } catch (err) {
          console.warn('[wishlist-detail] search config parse failed:', err);
        }
        this.buyerPriceCache = new Map();
        this.buyerPriceInFlight = new Map();
        this.qtyWriteTimers = new Map();
      },
      formatCount(count) {
        const n = Number(count) || 0;
        const template = n === 1 ? this.productCountOneLabel : this.productCountOtherLabel;
        return template.replace('__COUNT__', String(n));
      },
      resolveMode() {
        const params = new URLSearchParams(window.location.search);
        this.lid = params.get('lid');
        this.shareHash = params.get('share');
        // Guests are single-wishlist by design — treat a bare
        // `/pages/wishlist` visit as their detail view. The default lid
        // is looked up in hydrate() via the bridge once the SDK is
        // ready; until then, `mode === 'detail'` gates rendering of the
        // detail chrome but the content stays behind the loading state.
        const isGuestDefault = this.$root.dataset.wlGuestDefault === '1' && !this.lid && !this.shareHash;
        if (this.shareHash) this.mode = 'share';
        else if (this.lid || isGuestDefault) this.mode = 'detail';
        else this.mode = 'landing';
      },
      formatPrice(pr) {
        if (typeof pr !== 'number') return '';
        try {
          // `narrowSymbol` gives `$` instead of Intl's default `A$` for
          // AUD (which the generic `en` locale otherwise prefixes to
          // disambiguate). Matches Shopify's `| money` filter output.
          return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
            style: 'currency',
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD',
            currencyDisplay: 'narrowSymbol',
          }).format(pr);
        } catch (e) { return '$' + pr.toFixed(2); }
      },
      printPrice(pr) {
        const n = Number(pr);
        return Number.isFinite(n) ? this.formatPrice(n) : '';
      },
      printList() {
        window.print();
      },
      async hydrate() {
        if (this.mode === 'landing') { this.list = null; this.loading = false; return; }
        // Shared read-only view — `?share=<lid>` carries a list a shopper
        // marked public. Fetch it via the bridge's side-effect-free reader
        // so it renders for an unauthenticated recipient without folding
        // into the viewer's own wishlist state. No owner actions render
        // (the toolbar and card remove control are gated on mode==='detail').
        if (this.mode === 'share') {
          this.loading = true;
          this.fetchError = null;

          const SHARE_FETCH_ATTEMPTS = 4;
          let list = null;
          let lastError = 'not-found';
          for (let attempt = 0; attempt < SHARE_FETCH_ATTEMPTS; attempt++) {
            try {
              list = await window.EckList.getSharedList(this.shareHash);
              if (list) break;
              lastError = 'not-found';
            } catch (err) {
              lastError = err;
            }
            if (attempt < SHARE_FETCH_ATTEMPTS - 1) {
              await new Promise((resolve) => window.setTimeout(resolve, 700 * (attempt + 1)));
            }
          }
          if (list) {
            this.list = list;
            this.fetchError = null;
          } else {
            console.warn('[wishlist-detail] shared fetch failed:', lastError);
            this.list = null;
            this.fetchError = lastError;
          }
          this.loading = false;
          this._productsHydration = this.hydrateProducts();
          return;
        }
        // Guest bare-URL case — resolve the default wishlist lid from
        // the bridge before fetching. If they haven't added anything
        // yet, `getDefaultList` returns null → we render the empty
        // state instead of a not-found error.
        if (!this.lid && this.$root.dataset.wlGuestDefault === '1') {
          this.loading = true;
          try {
            const list = await window.EckList.getDefaultList();
            if (list && list.lid) {
              this.lid = list.lid;
            } else {
              this.list = null;
              this.fetchError = 'empty-guest';
              this.loading = false;
              return;
            }
          } catch (err) {
            console.warn('[wishlist-detail] guest default resolve failed:', err);
            this.fetchError = err;
            this.loading = false;
            return;
          }
        }
        if (!this.lid) { this.loading = false; return; }
        this.loading = true;
        this.fetchError = null;
        try {
          const list = await window.EckList.getList(this.lid);
          if (!list) {
            this.fetchError = 'not-found';
            this.list = null;
          } else {
            this.list = list;
            this.fetchError = null;
          }
        } catch (err) {
          console.warn('[wishlist-detail] fetch failed:', err);
          this.fetchError = err;
        } finally {
          this.loading = false;
        }
        this._productsHydration = this.hydrateProducts();
      },

      // ─── Storefront hydration ────────────────────────────────────────
      //
      //   One batched `nodes(ids:)` call returns full Product data for
      //   every product referenced by the current list, keyed by numeric
      //   product id (`empi`). Fields cover everything the wishlist card
      //   mirror needs: variants (image/price/compareAt/quantityRule),
      //   options (for swatches), tags + availability (for the badge),
      //   yotpo bottomline (for the rating), and unifd.brand metafield.
      //
      //   Prices here are base storefront prices — the query runs
      //   `@inContext(country:)` only (a `@inContext(buyer:)` query would
      //   need a customer access token the theme can't mint). For B2B/Trade
      //   customers `applyBuyerPricing()` overlays the buyer's contract
      //   price from the session `/products/{handle}.js` route on top; see
      //   the `buyerPrices` note above.

      async hydrateProducts() {
        // Outer finally flips `productsHydrated` for EVERY exit — including
        // the missing-token and empty-list early returns below — so the
        // add-all button un-gates once an attempt has run, even when no
        // fetch happened. The inner try/finally still owns `productsLoading`.
        try {
          if (!this.searchConfig || !this.searchConfig.shopDomain || !this.searchConfig.storefrontToken) return;
          if (!this.list || !Array.isArray(this.list.listcontents) || this.list.listcontents.length === 0) {
            this.productsById = {};
            return;
          }
          const uniqueEmpis = [...new Set(this.list.listcontents.map((it) => Number(it.empi)).filter(Boolean))];
          if (uniqueEmpis.length === 0) return;
          const ids = uniqueEmpis.map((n) => 'gid://shopify/Product/' + n);
          this.productsLoading = true;
          this.productsError = false;
          try {
            const url = 'https://' + this.searchConfig.shopDomain + '/api/' + (this.searchConfig.apiVersion || '2026-07') + '/graphql.json';
            const res = await fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Shopify-Storefront-Access-Token': this.searchConfig.storefrontToken,
              },
              body: JSON.stringify({ query: this.buildProductQuery(), variables: { ids } }),
            });
            if (!res.ok) throw new Error('storefront_http_' + res.status);
            const payload = await res.json();
            if (payload.errors && payload.errors.length) throw new Error('storefront_graphql_error');
            const nodes = (payload.data && payload.data.nodes) || [];
            const next = {};
            nodes.filter((n) => n && n.id).forEach((node) => {
              const numericId = this.numericIdFromGid(node.id);
              next[numericId] = node;
            });
            this.productsById = next;
          } catch (err) {
            console.warn('[wishlist-detail] product hydration failed:', err);
            this.productsError = true;
          } finally {
            this.productsLoading = false;
          }
        } finally {
          this.productsHydrated = true;
          // Fire-and-forget buyer-price overlay — B2B only, no-op otherwise.
          // Doesn't block the initial render; cards re-render reactively as
          // each handle's contract price resolves.
          this.applyBuyerPricing();
        }
      },

      // Fetch (and cache) the buyer-context prices for a product handle from
      // the session `/products/{handle}.js` route. Returns
      // Map<numericVariantId, {price, compareAtPrice}> or null on failure
      // (callers then keep the storefront price and never break).
      //
      // UNIT: `.js` `price` / `compare_at_price` are INTEGER CENTS (e.g.
      // 1250), while the card bindings + formatPrice() work in DECIMAL
      // DOLLARS (matching the Storefront `price.amount`), so divide by 100.
      async fetchBuyerPrices(handle) {
        if (!handle) return null;
        if (this.buyerPriceCache && this.buyerPriceCache.has(handle)) {
          return this.buyerPriceCache.get(handle);
        }
        if (this.buyerPriceInFlight && this.buyerPriceInFlight.has(handle)) {
          return this.buyerPriceInFlight.get(handle);
        }
        const promise = (async () => {
          try {
            const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
              headers: { 'Accept': 'application/json' },
              credentials: 'same-origin',
            });
            if (!res.ok) throw new Error('product_js_http_' + res.status);
            const product = await res.json();
            const map = new Map();
            (product.variants || []).forEach((v) => {
              map.set(Number(v.id), {
                price: v.price != null ? Number(v.price) / 100 : null,
                compareAtPrice: v.compare_at_price != null ? Number(v.compare_at_price) / 100 : null,
              });
            });
            if (this.buyerPriceCache) this.buyerPriceCache.set(handle, map);
            return map;
          } catch (err) {
            console.warn('[wishlist-detail] buyer price fetch failed:', err);
            return null;
          } finally {
            if (this.buyerPriceInFlight) this.buyerPriceInFlight.delete(handle);
          }
        })();
        if (this.buyerPriceInFlight) this.buyerPriceInFlight.set(handle, promise);
        return promise;
      },

      // Overlay buyer-context prices onto the displayed variants. B2B/Trade
      // only — B2C / guests skip entirely (no fetch). Gathers a product
      // handle for every list item (the hydrated `productsById` handle, or
      // the handle parsed from the Swym `du` for B2B-catalogue items the
      // Storefront token can't hydrate), fetches each once (cached +
      // de-duped), then reassigns `buyerPrices` so `cardFor()` recomputes.
      // Misses / failures leave the storefront price standing.
      applyBuyerPricing() {
        if (!this.searchConfig || !this.searchConfig.isB2B) return;
        const items = (this.list && Array.isArray(this.list.listcontents)) ? this.list.listcontents : [];
        if (items.length === 0) return;
        const handles = new Set();
        items.forEach((it) => {
          const product = this.productsById && this.productsById[Number(it.empi)];
          let handle = product && product.handle;
          if (!handle) handle = (String(it.du || '').match(/\/products\/([^?#/]+)/) || [null, ''])[1];
          if (handle) handles.add(handle);
        });
        handles.forEach(async (handle) => {
          const map = await this.fetchBuyerPrices(handle);
          if (!map || map.size === 0) return;
          const next = { ...this.buyerPrices };
          map.forEach((priced, variantId) => {
            next[variantId] = priced;
          });
          this.buyerPrices = next;
        });
      },

      numericIdFromGid(gid) {
        if (!gid) return null;
        const parts = String(gid).split('/');
        const tail = parts[parts.length - 1];
        const asNum = Number(tail);
        return Number.isFinite(asNum) ? asNum : tail;
      },

      // Merge Swym item state with the Storefront hydration node into a
      // single view model consumed by `wishlist-product-card`. When the
      // Storefront data hasn't arrived yet we fall back to the Swym-only
      // fields so the card still renders (image + title + variant + price).
      cardFor(item) {
        const product = this.productsById && this.productsById[Number(item.empi)];
        const swymPrice = typeof item.pr === 'number' ? item.pr : null;
        const swymImage = item.iu || '';
        const swymUrl = item.du || '';
        // Buyer-context contract price for this variant, if resolved. B2B
        // only (buyerPrices stays empty for B2C / guests).
        const buyerPrice = this.buyerPrices && this.buyerPrices[Number(item.epi)];
        if (!product) {
          // Attempt to derive a handle from the Swym `du` (e.g.
          // `/products/apollo-paint-carrier-wraps`) so the un-hydrated
          // fallback link still works cleanly.
          const swymHandle = (swymUrl.match(/\/products\/([^?#/]+)/) || [null, ''])[1];
          // Append the pinned variant so the PDP lands on it.
          const swymSep = swymUrl.indexOf('?') === -1 ? '?' : '&';
          const swymUrlWithVariant = swymUrl && item.epi
            ? swymUrl + swymSep + 'variant=' + encodeURIComponent(item.epi)
            : swymUrl;
          const fallbackPrice = buyerPrice && buyerPrice.price != null ? buyerPrice.price : swymPrice;
          const fallbackCompareAt = buyerPrice ? buyerPrice.compareAtPrice : null;
          return {
            hydrated: false,
            epi: item.epi,
            empi: item.empi,
            handle: swymHandle,
            url: swymUrlWithVariant,
            title: item.dt || '',
            brand: item.bt || '',
            variantTitle: item.vi || '',
            image: swymImage,
            price: fallbackPrice,
            compareAtPrice: fallbackCompareAt,
            badge: null,
            rating: null,
            swatches: [],
            available: true,
            // Default to true so the CTA reads "Choose options" — safer
            // than "Add to bag" for products whose variant count we
            // can't determine without Storefront hydration. The drawer
            // itself renders whatever variant form the product has.
            hasMultipleVariants: true,
            minQty: 1,
            // Neutral rule until Storefront hydration lands; the
            // `quantity:set-rule` push in the card re-snaps the selector
            // to the real floor the moment `card.moq` changes.
            moq: { min: 1, step: 1, max: null },
          };
        }
        const variantNode = ((product.variants && product.variants.nodes) || [])
          .find((v) => this.numericIdFromGid(v.id) === Number(item.epi));
        const brand = (product.brandMetafield && product.brandMetafield.value) || product.vendor || item.bt || '';
        const rating = this.parseRating(
          product.yotpoAvg && product.yotpoAvg.value,
          product.yotpoCount && product.yotpoCount.value
        );
        let price = variantNode && variantNode.price ? Number(variantNode.price.amount) : swymPrice;
        let compareAtPrice = variantNode && variantNode.compareAtPrice ? Number(variantNode.compareAtPrice.amount) : null;
        // Overlay the buyer's contract price (B2B) on top of the public
        // storefront price. Miss keeps the storefront price.
        if (buyerPrice) {
          if (buyerPrice.price != null) price = buyerPrice.price;
          compareAtPrice = buyerPrice.compareAtPrice;
        }
        const image = (variantNode && variantNode.image && variantNode.image.url)
          || (product.featuredImage && product.featuredImage.url)
          || swymImage;
        const available = variantNode ? this.variantInStock(variantNode) : true;
        const badge = this.computeBadge({ product, variantNode, price, compareAtPrice, available });
        const swatches = this.computeSwatches(product, variantNode);
        // Always use `handle` — `onlineStoreUrl` is null on password-
        // protected dev stores across all products, and even on public
        // stores it can point at a custom domain the theme fetches
        // can't reach.
        const url = '/products/' + encodeURIComponent(product.handle) + '?variant=' + encodeURIComponent(item.epi);
        const variantsList = (product.variants && product.variants.nodes) || [];
        const hasMultipleVariants = variantsList.length > 1;
        /* Full MOQ rule for the B2B / EDU requisition quantity selector and
           the single-variant direct-add quantity. Same precedence as the PDP
           (`blocks/product-buy-buttons`), card (`snippets/product-card`) and
           quick order: native B2B `quantityRule` first, then the Epicor
           `unifd.moq_*` metafields, floor of 1. */
        const moqRule = this.resolveVariantMoq(variantNode);
        const moq = {
          min: moqRule.minimum,
          step: moqRule.increment,
          max: this.resolveVariantMaxQty(variantNode, moqRule),
        };
        const minQty = moq.min;
        return {
          hydrated: true,
          epi: item.epi,
          empi: item.empi,
          handle: product.handle,
          url,
          title: product.title || item.dt || '',
          brand,
          variantTitle: variantNode ? variantNode.title : (item.vi || ''),
          image,
          price,
          compareAtPrice,
          badge,
          rating,
          swatches,
          available,
          hasMultipleVariants,
          minQty,
          moq,
        };
      },

      /* Resolve the MOQ rule for a Storefront variant node with the SAME
         precedence as the server-rendered PDP (`blocks/product-buy-buttons`),
         card (`snippets/product-card`) and quick order (`sections/quick-order`):
         native B2B `quantityRule` wins when it carries a real floor
         (minimum > 1); otherwise fall back to the Epicor-fed
         `unifd.moq_minimum` / `unifd.moq_increment` metafields. An increment
         with no explicit minimum implies the increment IS the floor. A
         non-positive metafield increment is meaningless -> treated as unset.
         Returns `{ minimum, increment, maximum }`. */
      resolveVariantMoq(v) {
        const nativeRule = (v && v.quantityRule) || {};
        const nativeMin = Number(nativeRule.minimum);
        if (Number.isFinite(nativeMin) && nativeMin > 1) {
          const nativeStep = Number(nativeRule.increment);
          return {
            minimum: nativeMin,
            increment: Number.isFinite(nativeStep) && nativeStep > 0 ? nativeStep : 1,
            maximum: nativeRule.maximum != null ? Number(nativeRule.maximum) : null,
          };
        }
        const parseMoq = (raw) => {
          if (raw == null || String(raw).trim() === '') return null;
          const n = Number(String(raw).trim());
          return Number.isFinite(n) ? n : null;
        };
        const mfMin = parseMoq(v && v.moqMinimum && v.moqMinimum.value);
        let mfStep = parseMoq(v && v.moqIncrement && v.moqIncrement.value);
        if (mfStep != null && mfStep <= 0) mfStep = null;
        let min = 1;
        let step = 1;
        if (mfMin != null) min = mfMin;
        if (mfStep != null) step = mfStep;
        if (mfMin == null && mfStep != null) min = mfStep;
        return { minimum: min, increment: step, maximum: null };
      },

      /* Effective upper bound for the quantity selector, mirroring
         `sections/quick-order`'s `resolveVariantMaxQty`. Returns null (NO cap)
         when the buyer's market oversells, the variant sells when out of
         stock, or the warehouse mirror is blank -- the same fail-open
         precedence `variantInStock` uses. Otherwise the cap is the mirror
         quantity, lowered to `quantityRule.maximum` when that is smaller, then
         grid-snapped down to the largest valid MOQ step so the ceiling is
         always an orderable quantity. */
      resolveVariantMaxQty(v, rule) {
        if (this.searchConfig && this.searchConfig.buyerOversells) return null;
        const sellWhenOutOfStock = ((v && v.sellWhenOutOfStock && v.sellWhenOutOfStock.value) || '')
          .trim()
          .toLowerCase();
        if (sellWhenOutOfStock === 'true' || sellWhenOutOfStock === '1') return null;
        const mirrorRaw = v && v.warehouseQuantity && v.warehouseQuantity.value;
        if (mirrorRaw == null || String(mirrorRaw).trim() === '') return null;
        const mirror = Number(mirrorRaw);
        if (!Number.isFinite(mirror) || mirror <= 0) return null;
        let cap = mirror;
        const nativeMax = rule && rule.maximum != null ? Number(rule.maximum) : null;
        if (nativeMax != null && Number.isFinite(nativeMax) && nativeMax < cap) cap = nativeMax;
        const min = Math.max(1, Number((rule && rule.minimum) || 1));
        const step = Math.max(1, Number((rule && rule.increment) || 1));
        if (cap < min) return null;
        const units = Math.floor((cap - min) / step);
        return min + units * step;
      },

      /* Copy for the MOQ notice under the requisition quantity selector.
         Same string and same minimum-only framing as the PDP's
         `product-buy-buttons__notice` (see `refreshMoqNotice` there), so the
         requisition list says what the product page says. Empty when the
         variant carries no floor, so unconstrained products render no banner
         at all. */
      cardMoqNotice(card) {
        const min = Number((card && card.moq && card.moq.min) || 1);
        if (min <= 1) return '';
        return (this.moqMultiplesTemplate || '').replace('__MIN__', min);
      },

      /* Push the card's resolved MOQ rule into its quantity selector. Called
         from the card's `x-effect` (which defers the call to `$nextTick`), so a
         rule arriving late with Storefront hydration re-snaps the input to the
         new floor. */
      applyQtyRule(el, rule, item) {
        if (!el) return;
        const target = el.querySelector('[x-data="quantitySelector"], .quantity-selector');
        if (!target) return;
        /* Reads of `this.quantities` / `item.qty` here are deliberately NOT
           tracked by the calling `x-effect` — it defers this call through
           `$nextTick`, so only the synchronous `card.moq` read is a
           dependency. That keeps the write-back in `setQty` from
           re-triggering the effect that pushed the value in. */
        const epi = Number(item && item.epi);
        const chosen = Number(this.quantities[epi]);
        const stored = Number(item && item.qty);
        let value = '';
        if (Number.isFinite(chosen) && chosen > 0) value = chosen;
        else if (Number.isFinite(stored) && stored > 0) value = stored;
        target.dispatchEvent(new CustomEvent('quantity:set-rule', {
          detail: {
            min: rule && rule.min ? rule.min : 1,
            step: rule && rule.step ? rule.step : 1,
            max: rule && rule.max != null ? rule.max : '',
            value,
          },
        }));
      },

      /* Quantity the requisition list will add for an item: this session's
         selector value, else the quantity stored on the Swym item when the
         line was saved (quick order and the save drawer both write `qty` —
         `sections/quick-order` reads it back the same way), else the MOQ
         floor. A stored value is snapped to the MOQ grid, since a line saved
         at 5 against a variant whose floor later moved to 10 is no longer
         orderable as-is. */
      qtyFor(item) {
        const epi = Number(item && item.epi);
        const chosen = Number(this.quantities[epi]);
        if (Number.isFinite(chosen) && chosen > 0) return chosen;
        const card = this.cardFor(item);
        const rule = (card && card.moq) || {};
        const min = Number(rule.min) > 0 ? Number(rule.min) : 1;
        const stored = Number(item && item.qty);
        if (!Number.isFinite(stored) || stored <= 0) return min;
        return this.snapQty(stored, rule);
      },

      /* Mirror of the quantity-selector's own clamp: snap to the step grid
         measured from `min`, then bound to [min, max]. */
      snapQty(value, rule) {
        const min = Number(rule && rule.min) > 0 ? Number(rule.min) : 1;
        const step = Number(rule && rule.step) > 0 ? Number(rule.step) : 1;
        const max = rule && rule.max != null ? Number(rule.max) : Infinity;
        const stepped = min + Math.round((value - min) / step) * step;
        return Math.max(min, Math.min(max, Math.round(stepped)));
      },

      setQty(epi, value) {
        const id = Number(epi);
        const qty = Number(value);
        if (!id || !Number.isFinite(qty) || qty <= 0) return;
        if (this.quantities[id] === qty) return;
        this.quantities[id] = qty;
        this.persistQty(id, qty);
      },

      /* Write the chosen quantity back to the Swym item so it survives a
         reload — a requisition list is a standing order, not a one-session
         basket. Debounced per line so holding the stepper sends one update.
         Signed-in detail view only: share mode is read-only and a guest's
         default wishlist exposes no per-item edit hook (the bridge no-ops
         those anyway). Fail-quiet — a failed write leaves the session value
         in place, so "Add all to bag" still uses what the buyer chose. */
      persistQty(epi, qty) {
        if (this.mode !== 'detail' || !this.lid) return;
        if (!window.EckList || !window.EckList.isSignedIn || !window.EckList.isSignedIn()) return;
        if (!this.qtyWriteTimers) this.qtyWriteTimers = new Map();
        const pending = this.qtyWriteTimers.get(epi);
        if (pending) clearTimeout(pending);
        this.qtyWriteTimers.set(epi, setTimeout(async () => {
          this.qtyWriteTimers.delete(epi);
          const item = (this.list && Array.isArray(this.list.listcontents) ? this.list.listcontents : [])
            .find((it) => Number(it.epi) === epi);
          if (!item) return;
          try {
            /* Send the complete item, not just the identifiers. Swym's "u"
               op replaces the stored item context with what it is given, so
               a minimal payload silently strips the display fields the
               theme put there (`iu`, `pr`, `dt`, `vi`) and leaves the line
               with no image, price or title on every wishlist surface. */
            await window.EckList.updateProduct(this.lid, {
              variantId: epi,
              productId: item.empi,
              url: item.du,
              qty,
              iu: item.iu,
              pr: item.pr,
              dt: item.dt,
              vi: item.vi,
              note: item.note,
              cprops: item.cprops,
            });
            // Keep the local item in step so a re-render (or a later
            // `cardFor` pass) reads the value that was just saved.
            item.qty = qty;
          } catch (err) {
            console.warn('[wishlist-detail] quantity write-back failed:', err);
          }
        }, 500));
      },

      /* Stock derived to match `snippets/variant-stock-state.liquid`:
         `unifd.sell_when_oos` is authoritative (truthy never forced OOS),
         then the `custom.warehouse_inventory_quantity` mirror wins when it
         carries a value, and when the mirror hasn't synced we fall back to
         Shopify's own tracked stock via `currentlyNotInStock`. Native
         `availableForSale` is useless here (always true under CONTINUE). */
      variantInStock(v) {
        if (!v) return true;
        if (this.searchConfig && this.searchConfig.buyerOversells) return true;
        const sellWhenOutOfStock = ((v.sellWhenOutOfStock && v.sellWhenOutOfStock.value) || '')
          .trim()
          .toLowerCase();
        if (sellWhenOutOfStock === 'true' || sellWhenOutOfStock === '1') return true;
        const mirrorRaw = v.warehouseQuantity && v.warehouseQuantity.value;
        if (mirrorRaw != null && String(mirrorRaw).trim() !== '') {
          const mirror = Number(mirrorRaw);
          if (Number.isFinite(mirror)) return mirror > 0;
        }
        /* Mirror not synced - `currentlyNotInStock` is true only for a
           TRACKED variant sitting at zero under a continue-selling policy,
           so untracked variants (which report false) stay sellable. */
        if (v.currentlyNotInStock === true) return false;
        return true;
      },

      parseRating(avgRaw, countRaw) {
        // Yotpo exposes the bottomline as two discrete
        // `single_line_text_field` metafields: `reviews_average` (the
        // average score) and `reviews_count` (the number of reviews).
        // Both arrive as strings, so coerce with Number.
        const avg = Number(avgRaw);
        const count = Number(countRaw || 0);
        if (!Number.isFinite(avg) || avg <= 0 || count <= 0) return null;
        return { value: avg.toFixed(1), count };
      },

      computeBadge({ product, variantNode, price, compareAtPrice, available }) {
        if (!available) return { label: this.soldOutLabel, colour: 'beige' };
        if (compareAtPrice != null && compareAtPrice > price) return { label: this.saleLabel, colour: 'crimson' };
        const tags = (product && product.tags) || [];
        if (tags.some((t) => String(t).toLowerCase() === 'new')) return { label: this.newLabel, colour: 'beige' };
        return null;
      },

      // Build the swatch strip for the pinned variant's colour option.
      // Storefront `options { name values }` gives us the option value
      // strings; we cross-reference `variants[].selectedOptions` to find
      // the matching variant per value (so we can flag OOS variants).
      // Actual swatch colour tokens are not exposed by the Storefront
      // options API — we bind each value's handle to a CSS custom
      // property so the theme's global colour tokens paint the swatch
      // when configured (`--color-<handle>`), falling back to grey.
      computeSwatches(product, pinnedVariant) {
        const opts = (product && product.options) || [];
        const colourOption = opts.find((o) => {
          const name = String(o.name || '').toLowerCase();
          return name === 'color' || name === 'colour';
        });
        if (!colourOption || !Array.isArray(colourOption.values) || colourOption.values.length < 2) return [];
        const variants = (product.variants && product.variants.nodes) || [];
        const pinnedValue = pinnedVariant
          ? (pinnedVariant.selectedOptions || []).find((o) => String(o.name).toLowerCase() === colourOption.name.toLowerCase())
          : null;
        const pinnedLabel = pinnedValue ? pinnedValue.value : null;
        return colourOption.values.map((value) => {
          const handle = String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          const matching = variants.find((v) => (v.selectedOptions || []).some((o) => o.name === colourOption.name && o.value === value));
          return {
            label: value,
            handle,
            isActive: value === pinnedLabel,
            isOos: matching ? !this.variantInStock(matching) : false,
          };
        });
      },

      formatRatingAria(value) {
        return (this.ratingTemplate || '').replace('__VALUE__', value);
      },

      // Built per call so the channel alias can be sourced from config
      // (mirrors `sections/quick-order`'s `buildSearchQuery`). Alias omitted
      // when the key is unset -> null -> fail-open. `productType` feeds the
      // gift-card exemption; other fields track the mirror card (swatch colour
      // isn't exposed — see computeSwatches).
      buildProductQuery() {
        const channelNs = (this.searchConfig && this.searchConfig.channelNamespace) || '';
        const channelKey = (this.searchConfig && this.searchConfig.channelKey) || '';
        const channelLine = channelNs && channelKey
          ? 'shopifyChannel: metafield(namespace: "' + channelNs + '", key: "' + channelKey + '") { value }'
          : '';
        return `
        query WishlistCards($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id
              title
              handle
              tags
              vendor
              productType
              featuredImage { url altText }
              options { name values }
              variants(first: 250) {
                nodes {
                  id
                  title
                  sku
                  currentlyNotInStock
                  warehouseQuantity: metafield(namespace: "custom", key: "warehouse_inventory_quantity") { value }
                  sellWhenOutOfStock: metafield(namespace: "unifd", key: "sell_when_oos") { value }
                  moqMinimum: metafield(namespace: "unifd", key: "moq_minimum") { value }
                  moqIncrement: metafield(namespace: "unifd", key: "moq_increment") { value }
                  ${channelLine}
                  price { amount }
                  compareAtPrice { amount }
                  image { url altText }
                  selectedOptions { name value }
                  quantityRule { minimum increment maximum }
                }
              }
              brandMetafield: metafield(namespace: "unifd", key: "brand") { value }
              yotpoAvg: metafield(namespace: "yotpo", key: "reviews_average") { value }
              yotpoCount: metafield(namespace: "yotpo", key: "reviews_count") { value }
            }
          }
        }
      `;
      },

      /* Client twin of `snippets/variant-channel-hidden.liquid`:
           - list contains "online"         -> visible
           - list present, no "online"      -> HIDDEN
           - list absent, B2C / gift card   -> visible
           - list absent, B2B non-gift-card -> HIDDEN (fail closed)
         The `value` is a JSON array string ('["online","pos"]'); parse and
         test membership, falling back to a substring test if unparseable. An
         empty array counts as absent (Liquid `blank`). */
      variantChannelHidden(node, product) {
        const raw = node && node.shopifyChannel && node.shopifyChannel.value;
        if (raw != null && String(raw).trim() !== '') {
          let list = null;
          try {
            list = JSON.parse(raw);
          } catch (e) {
            list = null;
          }
          if (Array.isArray(list)) {
            if (list.length === 0) return this.channelFailClosed(product);
            return !list.some((c) => String(c).trim().toLowerCase() === 'online');
          }
          return String(raw).toLowerCase().indexOf('online') === -1;
        }
        return this.channelFailClosed(product);
      },

      /* Absent-list decision: B2C and gift cards stay visible; a B2B
         non-gift-card fails closed (the B2B catalogue serves pos-only too). */
      channelFailClosed(product) {
        if (!(this.searchConfig && this.searchConfig.isB2B)) return false;
        if (this.isGiftCardProduct(product)) return false;
        return true;
      },

      /* Gift-card detection per repo convention (never native isGiftCard):
         product type "gift card" OR the `is-gift-card` tag. */
      isGiftCardProduct(product) {
        if (!product) return false;
        const type = String(product.productType || '').trim().toLowerCase();
        if (type === 'gift card') return true;
        const tags = (product.tags) || [];
        return tags.some((t) => String(t).trim().toLowerCase() === 'is-gift-card');
      },
      async removeItem(item) {
        if (!this.lid || !item) return;
        try {
          await window.EckList.removeProduct(this.lid, {
            variantId: item.epi,
            productId: item.empi,
            url: item.du,
          });
          // Client-side splice; the bridge will also fire swym:products-changed
          // which triggers a re-hydrate - but the local splice avoids a flash.
          if (this.list && Array.isArray(this.list.listcontents)) {
            this.list.listcontents = this.list.listcontents.filter((it) => it.epi !== item.epi);
          }
          document.dispatchEvent(new CustomEvent('wishlist:toast', {
            detail: { kind: 'removed', lid: this.lid, lname: this.list && this.list.lname, item },
            bubbles: true,
          }));
        } catch (err) {
          console.warn('[wishlist-detail] remove failed:', err);
        }
      },
      async shareList() {

        const base = (this.$root.dataset.wlShareBase || '/pages/wishlist').split('?')[0];
        let url = window.location.origin + base + '?share=' + encodeURIComponent(this.lid);
        try {
          await window.EckList.shareList(this.lid);
        } catch (err) {
          console.warn('[wishlist-detail] share (markPublic) failed, using current URL:', err);
          url = window.location.href;
        }
        try {
          if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            await navigator.clipboard.writeText(url);
          } else {
            const ta = document.createElement('textarea');
            ta.value = url;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); } finally { document.body.removeChild(ta); }
          }
          this.justCopied = true;
          if (this.copiedTimer) window.clearTimeout(this.copiedTimer);
          this.copiedTimer = window.setTimeout(() => { this.justCopied = false; }, 2500);
        } catch (err) {
          console.warn('[wishlist-detail] clipboard failed:', err);
        }
      },
      editList() {
        if (!this.list) return;
        document.dispatchEvent(new CustomEvent('wishlist:open-edit', {
          detail: { lid: this.lid, lname: this.list.lname || '' },
          bubbles: true,
        }));
      },
      deleteList() {
        if (!this.list) return;
        document.dispatchEvent(new CustomEvent('wishlist:open-delete', {
          detail: { lid: this.lid, lname: this.list.lname || '' },
          bubbles: true,
        }));
      },
      onRenamed(event) {
        const detail = event && event.detail;
        if (!detail || !this.list || detail.lid !== this.lid) return;
        // Local echo so the H1 updates without waiting for the swym event.
        this.list.lname = detail.lname;
      },
      onDeleted(event) {
        const detail = event && event.detail;
        if (!detail || detail.lid !== this.lid) return;
        // Land back on the landing view once the list is gone. Use the
        // current page path so this works on both /pages/wishlist and
        // /pages/quick-order without a hardcoded route.
        window.history.pushState({}, '', window.location.pathname);
        this.resolveMode();
        window.dispatchEvent(new PopStateEvent('popstate'));
      },
      async addAllToBag() {
        if (this.addingAll || !this.list || !Array.isArray(this.list.listcontents)) return;
        /* Belt-and-braces: even if a click somehow lands before the button's
           `productsHydrated` gate engages, await the in-flight hydration so
           the OOS skip below reads warehouse-mirror stock, not the
           un-hydrated `available: true` fallback. hydrateProducts() never
           rejects (internal catch + fail-open finally), but guard anyway. */
        if (this._productsHydration) {
          try { await this._productsHydration; } catch (e) {}
        }
        /* Drop out-of-stock variants before the batched add. `cardFor` carries
           the same stock decision the cards render (mirror + sell_when_oos +
           native fallback); un-hydrated items default to available and fall
           through to the checkout Function. */
        const items = [];
        let skipped = 0;
        let refused = 0;
        this.visibleContents.forEach((it) => {
          const id = Number(it.epi);
          if (!id) return;
          const card = this.cardFor(it);
          if (card && card.available === false) {
            skipped += 1;
            return;
          }
          items.push({ id, quantity: this.qtyFor(it) });
        });
        if (items.length === 0) {
          if (skipped > 0) this.notifyOosSkipped(skipped, true);
          return;
        }
        this.addingAll = true;
        try {
          /* Serialised cart write so the batched wishlist add can't race the
             PDP / quick-add / GWP surfaces into a 409. */
          let payload = null;
          try {
            payload = await window.theme.cartAdd(JSON.stringify({ items }));
          } catch (batchErr) {
            /* `/cart/add.js` is all-or-nothing, so ONE unorderable line -- a
               variant that has left the buyer's catalog comes back as
               "Cannot find variant" -- rejects the whole requisition order.
               A standing list of 40 lines shouldn't be blocked by one dead
               product, so fall back to adding line by line and report the
               casualties through the existing skipped-items toast. */
            console.warn('[wishlist-detail] batched add rejected, retrying per line:', batchErr, 'items:', items);
            const rejected = [];
            for (const entry of items) {
              try {
                payload = await window.theme.cartAdd(JSON.stringify({ items: [entry] }));
              } catch (lineErr) {
                /* Keep the cart's own reason against the line. A single-line
                   add is the only catalog-accurate purchasability test the
                   theme has: `/products/<handle>.js` answers from the online
                   store catalog, so it still reports a variant the buyer's
                   B2B catalog excludes as present and available. */
                const item = this.visibleContents.find((it) => Number(it.epi) === entry.id);
                rejected.push({
                  id: entry.id,
                  quantity: entry.quantity,
                  title: (item && item.dt) || '',
                  reason: (lineErr && lineErr.body && lineErr.body.description) || (lineErr && lineErr.message) || 'unknown',
                });
              }
            }
            if (rejected.length > 0) {
              console.warn('[wishlist-detail] lines the cart refused:', rejected);
              /* Counted apart from `skipped`: a line the cart won't take is
                 not out of stock, it is absent from this buyer's catalogue,
                 and telling them to wait for stock sends them looking for
                 something that will never arrive. */
              refused = rejected.length;
            }
            if (rejected.length === items.length) throw batchErr;
          }
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { item: payload && payload.items ? payload.items[0] : payload }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (skipped > 0) this.notifyOosSkipped(skipped, false);
          if (refused > 0) this.notifyUnavailableSkipped(refused, false);
        } catch (err) {
          console.warn('[wishlist-detail] add-all-to-bag failed:', err, 'items:', items);
          if (refused > 0) this.notifyUnavailableSkipped(refused, true);
          else if (skipped > 0) this.notifyOosSkipped(skipped, true);
        } finally {
          this.addingAll = false;
        }
      },
      /* Surface skipped out-of-stock items through the shared cart-add error
         toast (`cart:add:error` -> snippets/cart-add-error-toast.liquid). */
      notifyOosSkipped(count, allSkipped) {
        this.notifySkipped(count, allSkipped ? this.oosAllSkippedLabel : this.oosSomeSkippedLabel);
      },

      /* Lines `/cart/add.js` refused outright. Distinct from the out-of-stock
         skip: the variant resolves on the online store but not in the
         buyer's B2B catalogue, so no amount of waiting makes it orderable. */
      notifyUnavailableSkipped(count, allSkipped) {
        this.notifySkipped(count, allSkipped ? this.unavailableAllSkippedLabel : this.unavailableSomeSkippedLabel);
      },

      notifySkipped(count, template) {
        const message = String(template || '').replace('__COUNT__', count);
        document.dispatchEvent(new CustomEvent('cart:add:error', {
          detail: { error: { body: { message } }, tone: 'warning' },
          bubbles: true,
        }));
      },
      init() {
        this.hydrateLabels();
        this.isGuestDefault = this.$root.dataset.wlGuestDefault === '1';
        this.resolveMode();
        const onReady = () => this.hydrate();
        const onListsChanged = () => this.hydrate();
        const onProductsChanged = (event) => {
          const detail = event && event.detail;
          if (detail && detail.lid && detail.lid === this.lid) this.hydrate();
        };
        const onDegraded = () => { this.unavailable = true; };
        const onPopState = () => { this.resolveMode(); this.hydrate(); };
        const onRenamed = (event) => this.onRenamed(event);
        const onDeleted = (event) => this.onDeleted(event);
        if (window.EckList && window.EckList.mode === 'ready') onReady();
        if (window.EckList && window.EckList.mode === 'degraded') onDegraded();
        document.addEventListener('swym:ready', onReady);
        document.addEventListener('swym:lists-changed', onListsChanged);
        document.addEventListener('swym:products-changed', onProductsChanged);
        document.addEventListener('swym:degraded', onDegraded);
        document.addEventListener('wishlist:renamed', onRenamed);
        document.addEventListener('wishlist:deleted', onDeleted);
        window.addEventListener('popstate', onPopState);
        this.handlers = { onReady, onListsChanged, onProductsChanged, onDegraded, onPopState, onRenamed, onDeleted };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('swym:ready', this.handlers.onReady);
        document.removeEventListener('swym:lists-changed', this.handlers.onListsChanged);
        document.removeEventListener('swym:products-changed', this.handlers.onProductsChanged);
        document.removeEventListener('swym:degraded', this.handlers.onDegraded);
        document.removeEventListener('wishlist:renamed', this.handlers.onRenamed);
        document.removeEventListener('wishlist:deleted', this.handlers.onDeleted);
        window.removeEventListener('popstate', this.handlers.onPopState);
        this.handlers = null;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-landing"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistLanding', () => ({
      mode: 'landing',
      loading: true,
      lists: [],
      fetchError: null,
      unavailable: false,
      // Labels come from the `<script type="application/json" data-wl-landing-labels>`
      // blob inside the section root — hydrated in init().
      visibleLimit: 4,
      handlers: null,
      // Storefront search config (shop domain + token + buyer-oversell flag)
      // parsed from the section root in hydrateLabels(). Powers the on-demand
      // out-of-stock resolve in addAllToBag() — landing renders list summaries
      // only, so it holds no per-variant stock until the shopper adds to bag.
      searchConfig: null,
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.wlLandingLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[wishlist-landing] labels JSON parse failed:', err);
        }
        try {
          const raw = this.$root.dataset.wlLandingSearchConfig;
          if (raw) {
            const decoder = document.createElement('textarea');
            decoder.innerHTML = raw;
            this.searchConfig = JSON.parse(decoder.value);
          }
        } catch (err) {
          console.warn('[wishlist-landing] search config parse failed:', err);
        }
      },
      resolveMode() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('share')) this.mode = 'share';
        else if (params.get('lid')) this.mode = 'detail';
        else this.mode = 'landing';
      },
      formatPrice(pr) {
        if (typeof pr !== 'number') return '';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
            style: 'currency',
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD',
            currencyDisplay: 'narrowSymbol',
          }).format(pr);
        } catch (e) { return '$' + pr.toFixed(2); }
      },
      // Append `?variant=<epi>` to the Swym item URL so the PDP
      // preselects the pinned variant. Preserves any existing query
      // string on `du` (rare — Swym stores clean `/products/handle`).
      productUrl(item) {
        const base = item && item.du ? String(item.du) : '';
        if (!base || !item.epi) return base;
        const sep = base.indexOf('?') === -1 ? '?' : '&';
        return base + sep + 'variant=' + encodeURIComponent(item.epi);
      },
      formatCount(count) {
        const n = Number(count) || 0;
        const template = n === 1 ? this.productCountOneLabel : this.productCountOtherLabel;
        return template.replace('__COUNT__', String(n));
      },
      formatListsCount(count) {
        const n = Number(count) || 0;
        const template = n === 1 ? this.wishlistsCountOneLabel : this.wishlistsCountOtherLabel;
        return template.replace('__COUNT__', String(n));
      },
      normaliseLists(raw) {
        return (raw || []).map((l) => ({
          lid: l.lid,
          lname: l.lname,
          cnt: l.cnt || (Array.isArray(l.listcontents) ? l.listcontents.length : 0),
          items: (Array.isArray(l.listcontents) ? l.listcontents : []).slice(0, 8),
          _contents: Array.isArray(l.listcontents) ? l.listcontents : [],
          addingAll: false,
        }));
      },
      async hydrate() {
        if (this.mode !== 'landing') return;
        this.loading = true;
        this.fetchError = null;
        try {
          const raw = await window.EckList.getLists();
          this.lists = await this.pruneDeletedProducts(this.normaliseLists(raw));
        } catch (err) {
          console.warn('[wishlist-landing] fetch failed:', err);
          this.fetchError = err;
        } finally {
          this.loading = false;
        }
      },
      openCreate() {
        document.dispatchEvent(new CustomEvent('wishlist:open-create', { detail: {}, bubbles: true }));
      },
      navigateToDetail(lid) {
        const url = '/pages/wishlist?lid=' + encodeURIComponent(lid);
        window.history.pushState({}, '', url);
        this.resolveMode();
        window.dispatchEvent(new PopStateEvent('popstate'));
      },
      async addAllToBag(list) {
        if (!list || list.addingAll) return;
        list.addingAll = true;
        try {
          let contents = list.items || [];
          try {
            const full = await window.EckList.getList(list.lid);
            if (full && Array.isArray(full.listcontents) && full.listcontents.length) contents = full.listcontents;
          } catch (e) {}
          const raw = contents.map((it) => ({ id: Number(it.epi), quantity: 1 })).filter((x) => x.id);
          if (raw.length === 0) return;
          /* Saved-list summaries carry no stock data, so resolve each variant
             against the Storefront API and drop the out-of-stock ones before
             the add — same `variantInStock` precedence the detail page uses
             (buyer-oversell → sell_when_oos → warehouse mirror → native
             fallback). Awaited before filtering, so there's no pre-hydration
             race. Fails open (adds everything) if the lookup can't run. */
          const oosIds = await this.resolveOosVariantIds(raw.map((x) => x.id));
          const items = raw.filter((x) => !oosIds.has(x.id));
          const skipped = raw.length - items.length;
          if (items.length === 0) {
            if (skipped > 0) this.notifyOosSkipped(skipped, true);
            return;
          }
          /* Serialised cart write so the batched wishlist add can't race the
             PDP / quick-add / GWP surfaces into a 409. */
          const payload = await window.theme.cartAdd(JSON.stringify({ items }));
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { item: payload.items ? payload.items[0] : payload }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (skipped > 0) this.notifyOosSkipped(skipped, false);
        } catch (err) {
          console.warn('[wishlist-landing] add-all-to-bag failed:', err);
        } finally {
          list.addingAll = false;
        }
      },

      numericIdFromGid(gid) {
        if (!gid) return null;
        const parts = String(gid).split('/');
        const tail = parts[parts.length - 1];
        const asNum = Number(tail);
        return Number.isFinite(asNum) ? asNum : tail;
      },

      /* Stock derived to match `snippets/variant-stock-state.liquid` and the
         wishlist-detail / quick-order surfaces: `unifd.sell_when_oos` is
         authoritative (truthy never forced OOS), the
         `custom.warehouse_inventory_quantity` mirror wins when it carries a
         value, and when the mirror hasn't synced we fall back to Shopify's own
         tracked stock via `currentlyNotInStock`. Native `availableForSale` is
         useless here (always true under CONTINUE). */
      variantInStock(v) {
        if (!v) return true;
        if (this.searchConfig && this.searchConfig.buyerOversells) return true;
        const sellWhenOutOfStock = ((v.sellWhenOutOfStock && v.sellWhenOutOfStock.value) || '')
          .trim()
          .toLowerCase();
        if (sellWhenOutOfStock === 'true' || sellWhenOutOfStock === '1') return true;
        const mirrorRaw = v.warehouseQuantity && v.warehouseQuantity.value;
        if (mirrorRaw != null && String(mirrorRaw).trim() !== '') {
          const mirror = Number(mirrorRaw);
          if (Number.isFinite(mirror)) return mirror > 0;
        }
        if (v.currentlyNotInStock === true) return false;
        return true;
      },

      /* Resolve out-of-stock variant ids for a batch of variant ids via the
         Storefront API, reusing `variantInStock`. Returns a Set of numeric
         ids; fails open (empty Set) on any error or missing config. */
      async resolveOosVariantIds(numericIds) {
        const oos = new Set();
        if (!this.searchConfig || !this.searchConfig.shopDomain || !this.searchConfig.storefrontToken) return oos;
        const ids = Array.from(new Set((numericIds || []).filter(Boolean)));
        if (ids.length === 0) return oos;
        const gids = ids.map((id) => 'gid://shopify/ProductVariant/' + id);
        const query = `
          query variantStock($ids: [ID!]!) {
            nodes(ids: $ids) {
              ... on ProductVariant {
                id
                currentlyNotInStock
                warehouseQuantity: metafield(namespace: "custom", key: "warehouse_inventory_quantity") { value }
                sellWhenOutOfStock: metafield(namespace: "unifd", key: "sell_when_oos") { value }
              }
            }
          }
        `;
        try {
          const url = 'https://' + this.searchConfig.shopDomain + '/api/' + (this.searchConfig.apiVersion || '2026-07') + '/graphql.json';
          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.searchConfig.storefrontToken,
            },
            body: JSON.stringify({ query, variables: { ids: gids } }),
          });
          if (!res.ok) return oos;
          const payload = await res.json();
          const nodes = (payload.data && payload.data.nodes) || [];
          nodes.forEach((n) => {
            if (!n || !n.id) return;
            if (!this.variantInStock(n)) oos.add(this.numericIdFromGid(n.id));
          });
        } catch (err) {
          console.warn('[wishlist-landing] stock resolve failed:', err);
        }
        return oos;
      },

      /* Resolve which variant ids still map to a live, storefront-published
         product. A deleted or deactivated (archived / unpublished) product
         returns a null node from the Storefront `nodes` query, so its id never
         lands in the returned Set. Returns null when it can't tell (no config /
         token or a failed request) so callers fail open and show everything.
         Chunks to stay within the nodes() id limit. */
      async resolveValidVariantIds(numericIds) {
        if (!this.searchConfig || !this.searchConfig.shopDomain || !this.searchConfig.storefrontToken) return null;
        const ids = Array.from(new Set((numericIds || []).filter(Boolean)));
        if (ids.length === 0) return new Set();
        const valid = new Set();
        const url = 'https://' + this.searchConfig.shopDomain + '/api/' + (this.searchConfig.apiVersion || '2026-07') + '/graphql.json';
        const query = `
          query wishlistValidity($ids: [ID!]!) {
            nodes(ids: $ids) {
              ... on ProductVariant { id }
            }
          }
        `;
        try {
          for (let i = 0; i < ids.length; i += 250) {
            const gids = ids.slice(i, i + 250).map((id) => 'gid://shopify/ProductVariant/' + id);
            const res = await fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Shopify-Storefront-Access-Token': this.searchConfig.storefrontToken,
              },
              body: JSON.stringify({ query, variables: { ids: gids } }),
            });
            if (!res.ok) return null;
            const payload = await res.json();
            const nodes = (payload.data && payload.data.nodes) || [];
            nodes.forEach((n) => {
              if (n && n.id) valid.add(this.numericIdFromGid(n.id));
            });
          }
        } catch (err) {
          console.warn('[wishlist-landing] validity resolve failed:', err);
          return null;
        }
        return valid;
      },

      /* Drop deleted / deactivated products from each list's preview images and
         count. The landing renders straight from Swym, which keeps items that no
         longer resolve to a live product; validate every item's variant against
         the Storefront and rebuild `items` + `cnt` from the survivors. Fails
         open per list: if the resolver can't tell, or a whole list resolves
         empty (a token / catalogue-scope quirk rather than every item being
         deleted), that list is left untouched. */
      async pruneDeletedProducts(lists) {
        try {
          const perList = await Promise.all((lists || []).map(async (l) => {
            let contents = Array.isArray(l._contents) ? l._contents : [];
            if (contents.length < (l.cnt || 0)) {
              try {
                const full = await window.EckList.getList(l.lid);
                if (full && Array.isArray(full.listcontents)) contents = full.listcontents;
              } catch (err) {
                /* keep the summary contents we already have */
              }
            }
            return { list: l, contents };
          }));
          const allIds = [];
          perList.forEach(({ contents }) => contents.forEach((it) => {
            const id = Number(it.epi);
            if (id) allIds.push(id);
          }));
          const valid = await this.resolveValidVariantIds(allIds);
          if (!valid) return lists;
          return perList.map(({ list, contents }) => {
            const live = contents.filter((it) => valid.has(Number(it.epi)));
            if (contents.length > 0 && live.length === 0) return list;
            return { ...list, items: live.slice(0, 8), cnt: live.length };
          });
        } catch (err) {
          console.warn('[wishlist-landing] prune deleted failed:', err);
          return lists;
        }
      },

      /* Surface skipped out-of-stock items through the shared cart-add error
         toast (`cart:add:error` -> snippets/cart-add-error-toast.liquid),
         matching the detail + quick-order warning-tone path. */
      notifyOosSkipped(count, allSkipped) {
        const template = allSkipped ? this.oosAllSkippedLabel : this.oosSomeSkippedLabel;
        const message = String(template || '').replace('__COUNT__', count);
        document.dispatchEvent(new CustomEvent('cart:add:error', {
          detail: { error: { body: { message } }, tone: 'warning' },
          bubbles: true,
        }));
      },
      init() {
        this.hydrateLabels();
        this.resolveMode();
        // Responsive slice — 4 thumbs + overflow tile on mobile, 8 on
        // desktop. matchMedia is the source of truth; Alpine re-renders
        // the x-for when `visibleLimit` changes.
        const desktopMq = window.matchMedia('(min-width: 769px)');
        const applyLimit = (e) => { this.visibleLimit = (e && e.matches != null ? e.matches : desktopMq.matches) ? 8 : 4; };
        applyLimit();
        desktopMq.addEventListener('change', applyLimit);
        const onReady = () => this.hydrate();
        const onListsChanged = () => this.hydrate();
        const onProductsChanged = () => this.hydrate();
        const onDegraded = () => { this.unavailable = true; };
        // Re-hydrate on navigation so returning to the landing (e.g. after
        // deleting or renaming a list in the detail view) reflects the
        // current lists instead of the stale pre-navigation snapshot.
        // hydrate() self-guards on `mode === 'landing'`, so this is a no-op
        // when navigating into a detail / share view.
        const onPopState = () => { this.resolveMode(); this.hydrate(); };
        if (window.EckList && window.EckList.mode === 'ready') onReady();
        if (window.EckList && window.EckList.mode === 'degraded') onDegraded();
        document.addEventListener('swym:ready', onReady);
        document.addEventListener('swym:lists-changed', onListsChanged);
        document.addEventListener('swym:products-changed', onProductsChanged);
        document.addEventListener('swym:degraded', onDegraded);
        window.addEventListener('popstate', onPopState);
        this.handlers = { onReady, onListsChanged, onProductsChanged, onDegraded, onPopState, desktopMq, applyLimit };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('swym:ready', this.handlers.onReady);
        document.removeEventListener('swym:lists-changed', this.handlers.onListsChanged);
        document.removeEventListener('swym:products-changed', this.handlers.onProductsChanged);
        document.removeEventListener('swym:degraded', this.handlers.onDegraded);
        window.removeEventListener('popstate', this.handlers.onPopState);
        if (this.handlers.desktopMq && this.handlers.applyLimit) {
          this.handlers.desktopMq.removeEventListener('change', this.handlers.applyLimit);
        }
        this.handlers = null;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-picker-modal"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('wishlistPicker', () => ({
      loading: false,
      saving: false,
      lists: [],
      dropdownOpen: false,
      context: null, // { variantId, productId, url, prechecked }
      loadingLabel: 'Loading your wishlists...',
      emptyLabel: "You don't have any wishlists yet.",
      createLabel: 'Create new wishlist',
      saveLabel: 'Save',
      savingLabel: 'Saving...',
      handlers: null,
      get checkedCount() {
        return this.lists.filter((l) => l.checked).length;
      },
      get triggerValue() {
        return this.lists
          .filter((l) => l.checked)
          .map((l) => l.lname)
          .join(', ');
      },
      hydrateLabels() {
        try {
          const raw = this.$root.dataset.wlPickerLabels;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => { decoder.innerHTML = s; return decoder.value; };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              this[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[wishlist-picker] labels JSON parse failed:', err);
        }
      },
      toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
      },
      closeDropdown() {
        this.dropdownOpen = false;
      },
      async open(event) {
        const detail = (event && event.detail) || {};
        const price = typeof detail.price === 'number' && Number.isFinite(detail.price) ? detail.price : null;
        this.context = {
          variantId: Number(detail.variantId),
          productId: Number(detail.productId),
          url: String(detail.url || ''),
          title: detail.title || '',
          variantTitle: detail.variantTitle || '',
          image: detail.image || '',
          price: price,
          prechecked: Array.isArray(detail.prechecked) ? detail.prechecked : [],
        };
        const dialog = document.getElementById('wishlist-picker-drawer');
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        } else {
          dialog.setAttribute('open', '');
        }
        this.dropdownOpen = false;
        this.loading = true;
        try {
          const rawLists = await window.EckList.getLists();
          // `initialChecked` mirrors actual list membership — the source
          // of truth for the save-diff (toAdd / toRemove). Always fetched.
          const membership = new Set();
          if (this.context.variantId) {
            const active = await window.EckList.productListMembership(this.context.variantId).catch(() => []);
            (active || []).forEach((lid) => membership.add(lid));
          }
          // `prechecked` from the caller is a UX hint for the initial UI
          // state — used by the empty-heart single-list flow to pre-tick
          // the sole list so Save is one click. When provided, it drives
          // `checked`; otherwise we mirror actual membership.
          const uiHint = new Set(this.context.prechecked);
          const useUiHint = uiHint.size > 0;
          this.lists = (rawLists || []).map((l) => ({
            lid: l.lid,
            lname: l.lname,
            cnt: l.cnt || (Array.isArray(l.listcontents) ? l.listcontents.length : 0),
            checked: useUiHint ? uiHint.has(l.lid) : membership.has(l.lid),
            initialChecked: membership.has(l.lid),
          }));
        } catch (err) {
          console.warn('[wishlist-picker] fetch failed:', err);
          this.lists = [];
        } finally {
          this.loading = false;
        }
      },
      // Local-only toggle — no network. The CTA below stages changes and
      // fires them on click.
      toggle(list) {
        list.checked = !list.checked;
      },
      async commitSelection() {
        if (this.saving) return;
        if (!this.context || !this.context.variantId) return;
        const toAdd = this.lists.filter((l) => l.checked && !l.initialChecked);
        const toRemove = this.lists.filter((l) => !l.checked && l.initialChecked);
        if (toAdd.length === 0 && toRemove.length === 0) {
          // Nothing changed — treat as a benign close.
          this.close();
          return;
        }
        this.saving = true;
        const item = {
          dt: this.context.title,
          vi: this.context.variantTitle,
          iu: this.context.image,
          pr: this.context.price,
          du: this.context.url,
          epi: this.context.variantId,
          empi: this.context.productId,
        };
        try {
          for (const list of toAdd) {
            try {
              await window.EckList.addProduct(list.lid, this.context);
              list.initialChecked = true;
              document.dispatchEvent(new CustomEvent('wishlist:toast', {
                detail: {
                  variantId: this.context.variantId,
                  productId: this.context.productId,
                  url: this.context.url,
                  lid: list.lid,
                  lname: list.lname,
                  kind: 'added',
                  item,
                },
                bubbles: true,
              }));
            } catch (err) {
              console.warn('[wishlist-picker] add to', list.lid, 'failed:', err);
            }
          }
          for (const list of toRemove) {
            try {
              await window.EckList.removeProduct(list.lid, this.context);
              list.initialChecked = false;
              document.dispatchEvent(new CustomEvent('wishlist:toast', {
                detail: {
                  variantId: this.context.variantId,
                  productId: this.context.productId,
                  url: this.context.url,
                  lid: list.lid,
                  lname: list.lname,
                  kind: 'removed',
                  item,
                },
                bubbles: true,
              }));
            } catch (err) {
              console.warn('[wishlist-picker] remove from', list.lid, 'failed:', err);
            }
          }
          this.close();
        } finally {
          this.saving = false;
        }
      },
      close() {
        const dialog = document.getElementById('wishlist-picker-drawer');
        if (dialog && typeof dialog.close === 'function') dialog.close();
      },
      openCreate() {
        const dialog = document.getElementById('wishlist-picker-drawer');
        if (dialog && typeof dialog.close === 'function') dialog.close();
        document.dispatchEvent(new CustomEvent('wishlist:open-create', {
          detail: this.context || {},
          bubbles: true,
        }));
      },
      init() {
        this.hydrateLabels();
        const onOpen = (event) => this.open(event);
        document.addEventListener('wishlist:open-picker', onOpen);
        this.handlers = { onOpen };
      },
      destroy() {
        if (!this.handlers) return;
        document.removeEventListener('wishlist:open-picker', this.handlers.onOpen);
        this.handlers = null;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-toast"]) return;
  try {
    
  (function () {
    let toastTimer = null;

    /* Resolve the suffix text for the current event. Templates carry
       a `__LNAME__` sentinel that we replace with the real list name
       at runtime; the *_generic variants have no sentinel and are
       used as a fallback when no list name was supplied. */
    function suffixFor(toast, kind, lname) {
      const ds = toast.dataset;
      const listName = lname ? String(lname) : '';
      if (kind === 'removed') {
        if (listName && ds.removedSuffix) {
          return ds.removedSuffix.replace('__LNAME__', listName);
        }
        return ds.removedSuffixGeneric || '';
      }
      if (listName && ds.addedSuffix) {
        return ds.addedSuffix.replace('__LNAME__', listName);
      }
      return ds.addedSuffixGeneric || '';
    }

    function showWishlistToast(detail) {
      const toast = document.querySelector('[data-wishlist-toast]');
      if (!toast) return;
      const titleNode = toast.querySelector('[data-wishlist-toast-title]');
      const suffixNode = toast.querySelector('[data-wishlist-toast-suffix]');
      const variantNode = toast.querySelector('[data-wishlist-toast-variant]');
      const imageNode = toast.querySelector('[data-wishlist-toast-image]');
      const item = detail.item || {};
      const productTitle = item.dt || item.product_title || item.title || 'Item';
      const variantTitle = item.vi || item.variant_title || '';
      const imageSrc = item.iu || item.image || (item.featured_image && item.featured_image.url);

      if (titleNode) titleNode.textContent = productTitle;
      if (suffixNode) suffixNode.textContent = suffixFor(toast, detail.kind, detail.lname);
      if (variantNode) {
        if (variantTitle) {
          variantNode.textContent = variantTitle;
          variantNode.hidden = false;
        } else {
          variantNode.textContent = '';
          variantNode.hidden = true;
        }
      }
      if (imageNode) {
        if (imageSrc) {
          imageNode.src = imageSrc;
          imageNode.alt = productTitle;
        } else {
          imageNode.removeAttribute('src');
          imageNode.alt = '';
        }
      }
      toast.setAttribute('data-active', '');
      toast.setAttribute('aria-hidden', 'false');
      const delay = Number(toast.dataset.autoDismissMs) || 5000;
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => {
        toast.removeAttribute('data-active');
        toast.setAttribute('aria-hidden', 'true');
      }, delay);
    }

    document.addEventListener('wishlist:toast', (event) => {
      if (event && event.detail) showWishlistToast(event.detail);
    });

    /* Cart -> wishlist bridge. When a shopper clicks "Save for later"
       on a cart line, we (1) add the variant to their default list
       (creating "Favourites" if none exists), (2) remove the line
       from cart, and (3) surface a confirmation toast. Save-for-later
       is fire-and-forget; failures are logged and the cart line is
       left in place so the shopper can retry. */
    async function saveForLaterHandler(detail) {
      if (!window.EckList) return;
      const variantId = Number(detail.variantId);
      const productId = Number(detail.productId);
      const url = String(detail.url || '');
      const title = String(detail.title || '');
      const lineKey = detail.key;
      if (!variantId || !productId || !url || !lineKey) {
        console.warn('[wishlist-toast] save-for-later payload incomplete', detail);
        return;
      }
      try {
        const defaultList = await window.EckList.getDefaultList({ createIfMissing: 'Favourites' });
        if (!defaultList || !defaultList.lid) return;
        // Dedupe: only add if the variant isn't already in the default list.
        // Save-for-later is a "move" - the cart-remove still runs even if the
        // variant was already saved earlier.
        const alreadyInList = (defaultList.listcontents || []).some((it) => Number(it.epi) === variantId);
        if (!alreadyInList) {
          await window.EckList.addProduct(defaultList.lid, { variantId, productId, url });
        }
        const cartRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(lineKey), quantity: 0 }),
        });
        if (!cartRes.ok) throw new Error('cart-change failed');
        document.dispatchEvent(new CustomEvent('wishlist:toast', {
          detail: {
            kind: 'added',
            lid: defaultList.lid,
            lname: defaultList.lname,
            variantId, productId, url,
            item: { dt: title, du: url, epi: variantId, empi: productId },
          },
          bubbles: true,
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (err) {
        console.warn('[wishlist-toast] save-for-later failed:', err);
      }
    }

    document.addEventListener('cart-item:save-for-later', (event) => {
      if (event && event.detail) saveForLaterHandler(event.detail);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
